import { ErrorConstant, ExtensionPriority, __INTERNAL_REMIRROR_IDENTIFIER_KEY__, RemirrorIdentifier, ManagerPhase, ExtensionTag, MarkGroup, NodeGroup, EMPTY_PARAGRAPH_NODE, EDITOR_CLASS_NAME } from '@remirror/core-constants';
export * from '@remirror/core-constants';
import { invariant, freeze, object, keys, deepMerge, isEmptyArray, omit, noop, isPlainObject, isArray, isRemirrorType, isIdentifierOfType, bool, uniqueBy, Cast, entries, uniqueArray, isFunction, isNullOrUndefined, isString, toString, isUndefined, isEmptyObject, pick, uniqueId, sort, getLazyArray } from '@remirror/core-helpers';
export * from '@remirror/core-helpers';
export * from '@remirror/core-types';
import { isNodeActive, isMarkActive, mergeProsemirrorKeyBindings, convertCommand, mergeKeyBindings, getPluginState, isElementDomNode, isProsemirrorNode, isProsemirrorMark, isTextSelection, getDocument, getTextSelection, toHtml, createDocumentNode } from '@remirror/core-utils';
export * from '@remirror/core-utils';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import _classPrivateFieldGet from '@babel/runtime/helpers/esm/classPrivateFieldGet';
import _classPrivateFieldSet from '@babel/runtime/helpers/esm/classPrivateFieldSet';
import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import { inputRules, undoInputRule } from '@remirror/pm/inputrules';
import { baseKeymap, chainCommands, selectParentNode } from '@remirror/pm/commands';
import { keymap } from '@remirror/pm/keymap';
import { PluginKey, Plugin, EditorState } from '@remirror/pm/state';
import { Schema } from '@remirror/pm/model';
import { suggest, addSuggester, getSuggestPluginState } from '@remirror/pm/suggest';
import { cx } from 'linaria';
import { createNanoEvents } from 'nanoevents';

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function defaultEquals(valueA, valueB) {
  return valueA === valueB;
}
/**
 * Get the property changes and the next value from an update.
 */


function getChangedOptions(parameter) {
  var previousOptions = parameter.previousOptions,
      update = parameter.update,
      _parameter$equals = parameter.equals,
      equals = _parameter$equals === void 0 ? defaultEquals : _parameter$equals;
  var next = freeze(_objectSpread(_objectSpread({}, previousOptions), update));
  var changes = object();
  var optionKeys = keys(previousOptions);

  var _iterator = _createForOfIteratorHelper(optionKeys),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var key = _step.value;
      var previousValue = previousOptions[key];
      var value = next[key];

      if (equals(previousValue, value)) {
        changes[key] = {
          changed: false
        };
        continue;
      }

      changes[key] = {
        changed: true,
        previousValue,
        value
      };
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  var pickChanged = keys => {
    var picked = object();

    var _iterator2 = _createForOfIteratorHelper(keys),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var key = _step2.value;
        var item = changes[key];

        if (item === null || item === void 0 ? void 0 : item.changed) {
          picked[key] = item.value;
        }
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }

    return picked;
  };

  return {
    changes: freeze(changes),
    options: next,
    pickChanged
  };
}
var codeLabelMap = {
  [ErrorConstant.DUPLICATE_HELPER_NAMES]: 'helper method',
  [ErrorConstant.DUPLICATE_COMMAND_NAMES]: 'command method'
};
/**
 * Checks whether a given string is unique to the set. Add the name if it
 * doesn't already exist, or throw an error when `shouldThrow` is true.
 *
 * @param parameter - destructured params
 */

function throwIfNameNotUnique(parameter) {
  var name = parameter.name,
      set = parameter.set,
      code = parameter.code;
  var label = codeLabelMap[code];
  !!set.has(name) ? process.env.NODE_ENV !== "production" ? invariant(false, {
    code,
    message: "There is a naming conflict for the name: ".concat(name, " used in this '").concat(label, "'. Please rename or remove from the editor to avoid runtime errors.")
  }) : invariant(false) : void 0;
  set.add(name);
}

function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$1(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createForOfIteratorHelper$1(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray$1(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray$1(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$1(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$1(o, minLen); }

function _arrayLikeToArray$1(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var IGNORE = '__IGNORE__';

var _initialOptions = /*#__PURE__*/new WeakMap();

var _dynamicKeys = /*#__PURE__*/new WeakMap();

var _options = /*#__PURE__*/new WeakMap();

var _mappedHandlers = /*#__PURE__*/new WeakMap();

class BaseClass {
  /**
   * The default options for this extension.
   *
   * TODO see if this can be cast to something other than any and allow composition.
   */

  /**
   * The static keys for this class.
   */

  /**
   * The event handler keys.
   */

  /**
   * Customize the way the handler should behave.
   */

  /**
   * The custom keys.
   */

  /**
   * The unique name of this extension.
   *
   * @remarks
   *
   * Every extension **must** have a name. The name should have a distinct type
   * to allow for better type inference for end users. By convention the name
   * should be `camelCased` and unique within your editor instance.
   *
   * ```ts
   * class SimpleExtension extends Extension {
   *   get name() {
   *     return 'simple' as const;
   *   }
   * }
   * ```
   */

  /**
   * The options for this extension.
   *
   * @remarks
   *
   * Options are composed of Static, Dynamic, Handlers and ObjectHandlers.
   *
   * - `Static` - set at instantiation by the constructor.
   * - `Dynamic` - optionally set at instantiation by the constructor and also
   *   set during the runtime.
   * - `Handlers` - can only be set during the runtime.
   * - `ObjectHandlers` - Can only be set during the runtime of the extension.
   */
  get options() {
    return _classPrivateFieldGet(this, _options);
  }
  /**
   * Get the dynamic keys for this extension.
   */


  get dynamicKeys() {
    return _classPrivateFieldGet(this, _dynamicKeys);
  }
  /**
   * The options that this instance was created with, merged with all the
   * default options.
   */


  get initialOptions() {
    return _classPrivateFieldGet(this, _initialOptions);
  }
  /**
   * The initial options at creation (used to reset).
   */


  constructor(_ref) {
    var validator = _ref.validator,
        defaultOptions = _ref.defaultOptions,
        code = _ref.code;

    _initialOptions.set(this, {
      writable: true,
      value: void 0
    });

    _dynamicKeys.set(this, {
      writable: true,
      value: void 0
    });

    _options.set(this, {
      writable: true,
      value: void 0
    });

    _mappedHandlers.set(this, {
      writable: true,
      value: void 0
    });

    validator(this.constructor, code);

    for (var _len = arguments.length, parameters = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      parameters[_key - 1] = arguments[_key];
    }

    var options = parameters[0];

    _classPrivateFieldSet(this, _mappedHandlers, object());

    this.populateMappedHandlers();

    _classPrivateFieldSet(this, _options, _classPrivateFieldSet(this, _initialOptions, deepMerge(defaultOptions, this.constructor.defaultOptions, options !== null && options !== void 0 ? options : object(), this.createDefaultHandlerOptions())));

    _classPrivateFieldSet(this, _dynamicKeys, this.getDynamicKeys()); // Triggers the `init` options update for this extension.


    this.init();
  }
  /**
   * This method is called by the extension constructor. It is not strictly a
   * lifecycle method since at this point the manager has not yet been
   * instantiated.
   *
   * @remarks
   *
   * It should be used instead of overriding the constructor which can lead to
   * problems.
   *
   * At this point
   * - `this.store` will throw an error since it doesn't yet exist.
   * - `this.type` in `NodeExtension` and `MarkExtension` will also throw an
   *   error since the schema hasn't been created yet.
   */


  init() {}
  /**
   * Clone the current instance with the provided options. If nothing is
   * provided it uses the same initial options as the current instance.
   */


  /**
   * Get the dynamic keys for this extension.
   */
  getDynamicKeys() {
    var dynamicKeys = [];
    var _this$constructor = this.constructor,
        customHandlerKeys = _this$constructor.customHandlerKeys,
        handlerKeys = _this$constructor.handlerKeys,
        staticKeys = _this$constructor.staticKeys;

    var _iterator = _createForOfIteratorHelper$1(keys(_classPrivateFieldGet(this, _options))),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _key2 = _step.value;

        if (staticKeys.includes(_key2) || handlerKeys.includes(_key2) || customHandlerKeys.includes(_key2)) {
          continue;
        }

        dynamicKeys.push(_key2);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return dynamicKeys;
  }
  /**
   * Throw an error if non dynamic keys are updated.
   */


  ensureAllKeysAreDynamic(update) {
    if (process.env.NODE_ENV === 'production') {
      return;
    }

    var invalid = [];

    var _iterator2 = _createForOfIteratorHelper$1(keys(update)),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var _key3 = _step2.value;

        if (_classPrivateFieldGet(this, _dynamicKeys).includes(_key3)) {
          continue;
        }

        invalid.push(_key3);
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }

    !isEmptyArray(invalid) ? process.env.NODE_ENV !== "production" ? invariant(false, {
      code: ErrorConstant.INVALID_SET_EXTENSION_OPTIONS,
      message: "Invalid properties passed into the 'setOptions()' method: ".concat(JSON.stringify(invalid), ".")
    }) : invariant(false) : void 0;
  }
  /**
   * Update the properties with the provided partial value when changed.
   */


  setOptions(update) {
    var _this$onSetOptions;

    var previousOptions = this.getDynamicOptions();
    this.ensureAllKeysAreDynamic(update);

    var _getChangedOptions = getChangedOptions({
      previousOptions,
      update
    }),
        changes = _getChangedOptions.changes,
        options = _getChangedOptions.options,
        pickChanged = _getChangedOptions.pickChanged;

    this.updateDynamicOptions(options); // Trigger the update handler so the extension can respond to any relevant property
    // updates.

    (_this$onSetOptions = this.onSetOptions) === null || _this$onSetOptions === void 0 ? void 0 : _this$onSetOptions.call(this, {
      reason: 'set',
      changes,
      options,
      pickChanged,
      initialOptions: _classPrivateFieldGet(this, _initialOptions)
    });
  }
  /**
   * Reset the extension properties to their default values.
   *
   * @nonVirtual
   */


  resetOptions() {
    var _this$onSetOptions2;

    var previousOptions = this.getDynamicOptions();

    var _getChangedOptions2 = getChangedOptions({
      previousOptions,
      update: _classPrivateFieldGet(this, _initialOptions)
    }),
        changes = _getChangedOptions2.changes,
        options = _getChangedOptions2.options,
        pickChanged = _getChangedOptions2.pickChanged;

    this.updateDynamicOptions(options); // Trigger the update handler so that child extension properties can also be
    // updated.

    (_this$onSetOptions2 = this.onSetOptions) === null || _this$onSetOptions2 === void 0 ? void 0 : _this$onSetOptions2.call(this, {
      reason: 'reset',
      options,
      changes,
      pickChanged,
      initialOptions: _classPrivateFieldGet(this, _initialOptions)
    });
  }
  /**
   * Override this to receive updates whenever the options have been updated on
   * this instance. This method is called after the updates have already been
   * applied to the instance. If you need more control over exactly how the
   * option should be applied you should set the option to be `Custom`.
   *
   * **Please Note**:
   *
   * This must be defined as a instance method and not a property since it is
   * called in the constructor.
   *
   * ```ts
   * class ThisPreset extends Preset {
   *   // GOOD ✅
   *   onSetOptions(parameter: OnSetOptionsParameter<Options>) {}
   *
   *    // BAD ❌
   *   onSetOptions = (parameter: OnSetOptionsParameter<Options>) => {}
   * }
   * ```
   *
   * @abstract
   */


  /**
   * Update the private options.
   */
  getDynamicOptions() {
    return omit(_classPrivateFieldGet(this, _options), [...this.constructor.customHandlerKeys, ...this.constructor.handlerKeys]);
  }
  /**
   * Update the dynamic options.
   */


  updateDynamicOptions(options) {
    _classPrivateFieldSet(this, _options, _objectSpread$1(_objectSpread$1({}, _classPrivateFieldGet(this, _options)), options));
  }
  /**
   * Set up the mapped handlers object with default values (an empty array);
   */


  populateMappedHandlers() {
    var _iterator3 = _createForOfIteratorHelper$1(this.constructor.handlerKeys),
        _step3;

    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var _key4 = _step3.value;
        _classPrivateFieldGet(this, _mappedHandlers)[_key4] = [];
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
  }
  /**
   * This is currently fudged together, I'm not sure it will work.
   */


  createDefaultHandlerOptions() {
    var _this = this;

    var methods = object();

    var _iterator4 = _createForOfIteratorHelper$1(this.constructor.handlerKeys),
        _step4;

    try {
      var _loop = function _loop() {
        var key = _step4.value;

        methods[key] = function () {
          var returnValue;

          var _iterator5 = _createForOfIteratorHelper$1(_classPrivateFieldGet(_this, _mappedHandlers)[key]),
              _step5;

          try {
            for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
              var handler = _step5.value;
              returnValue = handler(...arguments);
              var handlerKeyOptions = _this.constructor.handlerKeyOptions;
              var __ALL__ = handlerKeyOptions.__ALL__;
              var customization = handlerKeyOptions[key]; // Check if the method should cause an early return, based on the
              // return value.

              if (__ALL__ && __ALL__.earlyReturnValue !== IGNORE && returnValue === __ALL__.earlyReturnValue || customization && customization.earlyReturnValue !== IGNORE && returnValue === customization.earlyReturnValue) {
                return returnValue;
              }
            }
          } catch (err) {
            _iterator5.e(err);
          } finally {
            _iterator5.f();
          }

          return returnValue;
        };
      };

      for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator4.e(err);
    } finally {
      _iterator4.f();
    }

    return methods;
  }
  /**
   * Add a handler to the event handlers so that it is called along with all
   * the other handler methods.
   *
   * This is helpful for integrating react hooks which can be used in multiple
   * places. The original problem with fixed properties is that you can only
   * assign to a method once and it overwrites any other methods. This pattern
   * for adding handlers allows for multiple usages of the same handler in the
   * most relevant part of the code.
   *
   * More to come on this pattern.
   *
   * @nonVirtual
   */


  addHandler(key, method) {
    _classPrivateFieldGet(this, _mappedHandlers)[key].push(method); // Return a method for disposing of the handler.


    return () => _classPrivateFieldGet(this, _mappedHandlers)[key] = _classPrivateFieldGet(this, _mappedHandlers)[key].filter(handler => handler !== method);
  }
  /**
   * A method that can be used to add a custom handler. It is up to the
   * extension creator to manage the handlers and dispose methods.
   */


  addCustomHandler(key, value) {
    var _this$onAddCustomHand, _this$onAddCustomHand2;

    return (_this$onAddCustomHand = (_this$onAddCustomHand2 = this.onAddCustomHandler) === null || _this$onAddCustomHand2 === void 0 ? void 0 : _this$onAddCustomHand2.call(this, {
      [key]: value
    })) !== null && _this$onAddCustomHand !== void 0 ? _this$onAddCustomHand : noop;
  }
  /**
   * Override this method if you want to set custom handlers on your extension.
   *
   * This must return a dispose function.
   */


}
/**
 * @internal
 */

_defineProperty(BaseClass, "defaultOptions", {});

_defineProperty(BaseClass, "staticKeys", []);

_defineProperty(BaseClass, "handlerKeys", []);

_defineProperty(BaseClass, "handlerKeyOptions", {});

_defineProperty(BaseClass, "customHandlerKeys", []);

/**
 * Checks that the extension has a valid constructor with the `defaultOptions`
 * and `defaultProperties` defined as static properties.
 */
function isValidConstructor(Constructor, code) {
  !isPlainObject(Constructor.defaultOptions) ? process.env.NODE_ENV !== "production" ? invariant(false, {
    message: "No static 'defaultOptions' provided for '".concat(Constructor.name, "'.\n"),
    code
  }) : invariant(false) : void 0;
  !isArray(Constructor.staticKeys) ? process.env.NODE_ENV !== "production" ? invariant(false, {
    message: "No static 'staticKeys' provided for '".concat(Constructor.name, "'.\n"),
    code
  }) : invariant(false) : void 0;
  !isArray(Constructor.handlerKeys) ? process.env.NODE_ENV !== "production" ? invariant(false, {
    message: "No static 'handlerKeys' provided for '".concat(Constructor.name, "'.\n"),
    code
  }) : invariant(false) : void 0;
  !isArray(Constructor.customHandlerKeys) ? process.env.NODE_ENV !== "production" ? invariant(false, {
    message: "No static 'customHandlerKeys' provided for '".concat(Constructor.name, "'.\n"),
    code
  }) : invariant(false) : void 0;
}

/**
 * Auto infers the parameter for the constructor. If there is a
 * required static option then the TypeScript compiler will error if nothing is
 * passed in.
 */

var _priorityOverride = /*#__PURE__*/new WeakMap();

var _store = /*#__PURE__*/new WeakMap();

/**
 * Extensions are fundamental to the way that Remirror works by grouping
 * together the functionality and handling the management of similar concerns.
 *
 * @remarks
 *
 *  Extension can adjust editor functionality in any way. Here are some
 *  examples.
 *
 * - How the editor displays certain content, i.e. **bold**, _italic_,
 *   **underline**.
 * - Which commands should be made available e.g. `commands.toggleBold()` to
 *   toggle the weight of the selected text.
 * - Check if a command is currently enabled (i.e a successful dry run) e.g.
 *   `commands.toggleBold.isEnabled()`.
 * - Register Prosemirror `Plugin`s, `keymap`s, `InputRule`s `PasteRule`s,
 *   `Suggestions`, and custom `nodeViews` which affect the behavior of the
 *   editor.
 *
 * There are three types of `Extension`.
 *
 * - `NodeExtension` - For creating Prosemirror nodes in the editor. See
 *   {@link NodeExtension}
 * - `MarkExtension` - For creating Prosemirror marks in the editor. See
 *   {@link MarkExtension}
 * - `PlainExtension` - For behavior which doesn't map to a `ProsemirrorNode` or
 *   `Mark` and as a result doesn't directly affect the Prosemirror `Schema` or
 *   content. See {@link PlainExtension}.
 *
 * This `Extension` is an abstract class that should not be used directly but
 * rather extended to add the intended functionality.
 *
 * ```ts
 * import { PlainExtension, Static } from 'remirror/core';
 *
 * interface AwesomeExtensionOptions {
 *   isAwesome?: Static<boolean>;
 *   id?: string;
 * }
 *
 * class AwesomeExtension extends PlainExtension<AwesomeExtensionOptions> {
 *   static defaultOptions: DefaultExtensionOptions<AwesomeExtensionOptions> = {
 *     isAwesome: true,
 *     id: '',
 *   }
 *
 *   get name() {
 *     return 'awesome' as const;
 *   }
 * }
 * ```
 */
class Extension extends BaseClass {
  /**
   * The default priority for this family of extensions.
   */

  /**
   * Allows for the `RemirrorManager` or `Preset`'s to override the priority of an extension.
   */

  /**
   * The priority level for this instance of the extension. A higher value
   * corresponds to a higher priority extension
   */
  get priority() {
    var _ref, _classPrivateFieldGet2;

    return (_ref = (_classPrivateFieldGet2 = _classPrivateFieldGet(this, _priorityOverride)) !== null && _classPrivateFieldGet2 !== void 0 ? _classPrivateFieldGet2 : this.options.priority) !== null && _ref !== void 0 ? _ref : this.constructor.defaultPriority;
  }
  /**
   * The store is a property that's internal to extension. It include important
   * items like the `view` and `schema` that are added by the extension manager
   * and also the lifecycle extension methods.
   *
   * **NOTE** - The store is not available until the manager has been created and
   * received the extension. As a result trying to access the store during
   * `init` and `constructor` will result in a runtime error.
   *
   * Some properties of the store are available at different phases. You should
   * check the inline documentation to know when a certain property is useable
   * in your extension.
   */


  get store() {
    !_classPrivateFieldGet(this, _store) ? process.env.NODE_ENV !== "production" ? invariant(false, {
      code: ErrorConstant.MANAGER_PHASE_ERROR,
      message: "An error occurred while attempting to access the 'extension.store' when the Manager has not yet set created the lifecycle methods."
    }) : invariant(false) : void 0;
    return freeze(_classPrivateFieldGet(this, _store), {
      requireKeys: true
    });
  }
  /**
   * This store is can be modified by the extension manager with and lifecycle
   * extension methods.
   *
   * Different properties are added at different times so it's important to
   * check the documentation for each property to know what phase is being
   * added.
   */


  constructor() {
    for (var _len = arguments.length, parameters = new Array(_len), _key = 0; _key < _len; _key++) {
      parameters[_key] = arguments[_key];
    }

    super({
      validator: isValidExtensionConstructor,
      defaultOptions,
      code: ErrorConstant.INVALID_EXTENSION
    }, ...parameters);

    _priorityOverride.set(this, {
      writable: true,
      value: void 0
    });

    _store.set(this, {
      writable: true,
      value: void 0
    });
  }
  /**
   * Check if the type of this extension's constructor matches the type of the
   * provided constructor.
   */


  isOfType(Constructor) {
    return this.constructor === Constructor;
  }
  /**
   * Pass a reference to the globally shared `ExtensionStore` for this extension.
   *
   * @remarks
   *
   * The extension store allows extensions to access important variables without
   * complicating their creator methods.
   *
   * ```ts
   * import { PlainExtension } from 'remirror/core';
   *
   * class Awesome extends PlainExtension {
   *   customMethod() {
   *     if (this.store.view.hasFocus()) {
   *       log('dance dance dance');
   *     }
   *   }
   * }
   * ```
   *
   * This should only be called by the `RemirrorManager`.
   *
   * @internal
   * @nonVirtual
   */


  setStore(store) {
    if (_classPrivateFieldGet(this, _store)) {
      return;
    }

    _classPrivateFieldSet(this, _store, store);
  }
  /**
   * Clone an extension.
   */


  clone() {
    for (var _len2 = arguments.length, parameters = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      parameters[_key2] = arguments[_key2];
    }

    return new this.constructor(...parameters);
  }
  /**
   * Set the priority override for this extension. This is used in the
   * `RemirrorManager` in order to override the priority of an extension.
   *
   * If you set the first parameter to `undefined` it will remove the priority override.
   */


  setPriority(priority) {
    _classPrivateFieldSet(this, _priorityOverride, priority);
  }

}
/**
 * Declaration merging since the constructor property can't be defined on the
 * actual class.
 */


_defineProperty(Extension, "defaultPriority", ExtensionPriority.Default);

/**
 * Create a plain extension which doesn't directly map to Prosemirror nodes or
 * marks.
 *
 * Plain extensions are a great way to add custom behavior to your editor.
 */
class PlainExtension extends Extension {
  static get [__INTERNAL_REMIRROR_IDENTIFIER_KEY__]() {
    return RemirrorIdentifier.PlainExtensionConstructor;
  }

  get [__INTERNAL_REMIRROR_IDENTIFIER_KEY__]() {
    return RemirrorIdentifier.PlainExtension;
  }

}
/**
 * A mark extension is based on the `Mark` concept from from within prosemirror
 * {@link https://prosemirror.net/docs/guide/#schema.marks}
 *
 * @remarks
 *
 * Marks are used to add extra styling or other information to inline content.
 * Mark types are objects much like node types, used to tag mark objects and
 * provide additional information about them.
 */

class MarkExtension extends Extension {
  static get [__INTERNAL_REMIRROR_IDENTIFIER_KEY__]() {
    return RemirrorIdentifier.MarkExtensionConstructor;
  }
  /**
   * Whether to disable extra attributes for this extension.
   */


  get [__INTERNAL_REMIRROR_IDENTIFIER_KEY__]() {
    return RemirrorIdentifier.MarkExtension;
  }
  /**
   * Provides access to the mark type from the schema.
   *
   * @remarks
   *
   * The type is available when the manager initializes. So it can be used in
   * the outer scope of `createCommands`, `createHelpers`, `createKeymap` and
   * most of the creator methods.
   */


  get type() {
    return this.store.schema.marks[this.name];
  }

  constructor() {
    super(...arguments);
  }
  /**
   * Provide a method for creating the schema. This is required in order to
   * create a `MarkExtension`.
   *
   * @remarks
   *
   * The main difference between the return value of this method and Prosemirror
   * `MarkSpec` is that that the `toDOM` method doesn't allow dom manipulation.
   * You can only return an array or string.
   *
   * For more advanced requirements, it may be possible to create a `nodeView`
   * to manage the dom interactions.
   */


}

_defineProperty(MarkExtension, "disableExtraAttributes", false);

/**
 * Defines the abstract class for extensions which can place nodes into the
 * prosemirror state.
 *
 * @remarks
 *
 * For more information see {@link https://prosemirror.net/docs/ref/#model.Node}
 */
class NodeExtension extends Extension {
  static get [__INTERNAL_REMIRROR_IDENTIFIER_KEY__]() {
    return RemirrorIdentifier.NodeExtensionConstructor;
  }
  /**
   * Whether to disable extra attributes for this extension.
   */


  get [__INTERNAL_REMIRROR_IDENTIFIER_KEY__]() {
    return RemirrorIdentifier.NodeExtension;
  }
  /**
   * Provides access to the node type from the schema.
   */


  get type() {
    return this.store.schema.nodes[this.name];
  }

  constructor() {
    super(...arguments);
  }
  /**
   * Provide a method for creating the schema. This is required in order to
   * create a `NodeExtension`.
   *
   * @remarks
   *
   * A node schema defines the behavior of the content within the editor. This
   * is very tied to the prosemirror implementation and the best place to learn
   * more about it is in the
   * {@link https://prosemirror.net/docs/guide/#schema docs}.
   *
   * @params hole - a method that is meant to indicate where extra attributes
   * should be placed (if they exist).
   *
   * The `hole` is a function that augments the passed object adding a special
   * `secret` key which is used to insert the extra attributes setter.
   *
   * ```ts
   * import { NodeExtension, SpecHole } from 'remirror/core';
   *
   * class AwesomeExtension extends NodeExtension {
   *   get name() { return 'awesome' as const'; }
   *
   *   createNodeSpec() {
   *     return {
   *       toDOM: (node) => {
   *         return ['p', hole(), 0]
   *       }
   *     }
   *   }
   * }
   * ```
   *
   * The above example will have the `hole()` method call replaced with the
   * extra attributes.
   */


}

_defineProperty(NodeExtension, "disableExtraAttributes", false);

/**
 * These are the default options merged into every extension. They can be
 * overridden.
 */
var defaultOptions = {
  priority: undefined,
  extraAttributes: {},
  disableExtraAttributes: false,
  exclude: {}
};
/**
 * Mutate the default extension options.
 *
 * @remarks
 *
 * This is a dangerous method since it allows you to mutate the received object.
 * Don't use it unless you absolutely have to.
 *
 * A potential use case is for adding a new default option to all extensions. It
 * shows an example of how to accomplish this in a typesafe way.
 *
 * @example
 *
 * ```ts
 * import { mutateDefaultExtensionOptions } from 'remirror/core';
 *
 * mutateDefaultExtensionOptions((settings) => {
 *   // Set the default value of all extensions to have a property `customSetting` with value `false`.
 *   settings.customSetting = false;
 * })
 *
 * declare global {
 *   namespace Remirror {
 *     interface BaseExtensionOptions {
 *       customSetting?: boolean;
 *     }
 *   }
 * }
 * ```
 *
 * The mutation must happen before any extension have been instantiated.
 */

function mutateDefaultExtensionOptions(mutatorMethod) {
  mutatorMethod(defaultOptions);
}
/**
 * Determines if the passed value is an extension.
 *
 * @param value - the value to test
 */

function isExtension(value) {
  return isRemirrorType(value) && isIdentifierOfType(value, [RemirrorIdentifier.PlainExtension, RemirrorIdentifier.MarkExtension, RemirrorIdentifier.NodeExtension]);
}
/**
 * Checks that the extension has a valid constructor with the `defaultOptions`
 * and `defaultProperties` defined as static properties.
 */

function isValidExtensionConstructor(Constructor) {
  var code = ErrorConstant.INVALID_EXTENSION;
  !isExtensionConstructor(Constructor) ? process.env.NODE_ENV !== "production" ? invariant(false, {
    message: 'This is not a valid extension constructor',
    code
  }) : invariant(false) : void 0;
  isValidConstructor(Constructor, code);
}
/**
 * Determines if the passed value is an extension constructor.
 *
 * @param value - the value to test
 */

function isExtensionConstructor(value) {
  return isRemirrorType(value) && isIdentifierOfType(value, [RemirrorIdentifier.PlainExtensionConstructor, RemirrorIdentifier.MarkExtensionConstructor, RemirrorIdentifier.NodeExtensionConstructor]);
}
/**
 * Checks whether the provided value is a plain extension.
 *
 * @param value - the extension to check
 */

function isPlainExtension(value) {
  return isRemirrorType(value) && isIdentifierOfType(value, RemirrorIdentifier.PlainExtension);
}
/**
 * Determines if the passed in extension is a node extension. Useful as a type
 * guard where a particular type of extension is needed.
 *
 * @param value - the extension to check
 */

function isNodeExtension(value) {
  return isRemirrorType(value) && isIdentifierOfType(value, RemirrorIdentifier.NodeExtension);
}
/**
 * Determines if the passed in extension is a mark extension. Useful as a type
 * guard where a particular type of extension is needed.
 *
 * @param value - the extension to check
 */

function isMarkExtension(value) {
  return isRemirrorType(value) && isIdentifierOfType(value, RemirrorIdentifier.MarkExtension);
}

function ownKeys$2(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$2(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$2(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createForOfIteratorHelper$2(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray$2(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray$2(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$2(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$2(o, minLen); }

function _arrayLikeToArray$2(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var _attributeList = /*#__PURE__*/new WeakMap();

var _attributeObject = /*#__PURE__*/new WeakMap();

/**
 * This extension allows others extension to add the `createAttributes` method
 * for adding attributes to the prosemirror dom element.
 *
 * @remarks
 *
 * Use this to include all the dynamically generated attributes provided by each
 * extension. High priority extensions have preference over the lower priority
 * extensions.
 *
 * @builtin
 */
class AttributesExtension extends PlainExtension {
  constructor() {
    var _this;

    super(...arguments);
    _this = this;

    _attributeList.set(this, {
      writable: true,
      value: []
    });

    _attributeObject.set(this, {
      writable: true,
      value: object()
    });

    _defineProperty(this, "updateAttributes", function () {
      var triggerUpdate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      _this.transformAttributes();

      if (triggerUpdate) {
        _this.store.getCommands().forceUpdate('attributes');
      }
    });
  }

  get name() {
    return 'attributes';
  }

  /**
   * Create the attributes object on initialization.
   *
   * @internal
   */
  onCreate() {
    this.transformAttributes();
    this.store.setExtensionStore('updateAttributes', this.updateAttributes);
  }

  transformAttributes() {
    // Reset this attributes
    _classPrivateFieldSet(this, _attributeList, []);

    _classPrivateFieldSet(this, _attributeObject, object());

    var _iterator = _createForOfIteratorHelper$2(this.store.extensions),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _this$store$managerSe, _extension$options$ex;

        var extension = _step.value;

        if (!extension.createAttributes || ((_this$store$managerSe = this.store.managerSettings.exclude) === null || _this$store$managerSe === void 0 ? void 0 : _this$store$managerSe.attributes) || ((_extension$options$ex = extension.options.exclude) === null || _extension$options$ex === void 0 ? void 0 : _extension$options$ex.attributes)) {
          continue;
        } // Inserted at the start of the list so that when combining the full
        // attribute object the higher priority extension attributes are
        // preferred to the lower priority since they merge with the object
        // later.


        _classPrivateFieldGet(this, _attributeList).unshift(extension.createAttributes());
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    var _iterator2 = _createForOfIteratorHelper$2(_classPrivateFieldGet(this, _attributeList)),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var _classPrivateFieldGet2;

        var attributes = _step2.value;

        _classPrivateFieldSet(this, _attributeObject, _objectSpread$2(_objectSpread$2(_objectSpread$2({}, _classPrivateFieldGet(this, _attributeObject)), attributes), {}, {
          class: ((_classPrivateFieldGet2 = _classPrivateFieldGet(this, _attributeObject).class) !== null && _classPrivateFieldGet2 !== void 0 ? _classPrivateFieldGet2 : '') + (bool(attributes.class) ? attributes.class : '') || ''
        }));
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }

    this.store.setStoreKey('attributes', _classPrivateFieldGet(this, _attributeObject));
  }

}

function _createForOfIteratorHelper$3(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray$3(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray$3(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$3(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$3(o, minLen); }

function _arrayLikeToArray$3(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var _extensionStore = /*#__PURE__*/new WeakMap();

var _extensions = /*#__PURE__*/new WeakMap();

var _extensionMap = /*#__PURE__*/new WeakMap();

/**
 * A preset is our way of bundling similar extensions with unified options and
 * dynamic properties.
 */
class Preset extends BaseClass {
  /**
   * The default options for this preset.
   */

  /**
   * The preset constructor identifier key.
   *
   * @internal
   */
  static get [__INTERNAL_REMIRROR_IDENTIFIER_KEY__]() {
    return RemirrorIdentifier.PresetConstructor;
  }
  /**
   * The remirror identifier key.
   *
   * @internal
   */


  get [__INTERNAL_REMIRROR_IDENTIFIER_KEY__]() {
    return RemirrorIdentifier.Preset;
  }
  /**
   * The `camelCased` name of the preset.
   */


  get extensions() {
    return _classPrivateFieldGet(this, _extensions);
  }
  /**
   * The store is a property that's internal to the preset. It include important
   * items like the `view` and `schema` that are added by the editor manager.
   *
   * **NOTE** - The store is not available until the manager has been created and
   * received the extension. As a result trying to access the store during
   * `init` and `constructor` will result in a runtime error.
   */


  get extensionStore() {
    !_classPrivateFieldGet(this, _extensionStore) ? process.env.NODE_ENV !== "production" ? invariant(false, {
      code: ErrorConstant.MANAGER_PHASE_ERROR,
      message: "An error occurred while attempting to access the 'extension.store' when the Manager has not yet set upt the lifecycle methods."
    }) : invariant(false) : void 0;
    return freeze(_classPrivateFieldGet(this, _extensionStore), {
      requireKeys: true
    });
  }
  /**
   * This store is can be modified by the extension manager with and lifecycle
   * extension methods.
   *
   * Different properties are added at different times so it's important to
   * check the documentation for each property to know what phase is being
   * added.
   */


  constructor() {
    for (var _len = arguments.length, parameters = new Array(_len), _key = 0; _key < _len; _key++) {
      parameters[_key] = arguments[_key];
    }

    super({
      validator: isValidPresetConstructor,
      defaultOptions: {},
      code: ErrorConstant.INVALID_PRESET
    }, ...parameters); // Create the extension list.

    _extensionStore.set(this, {
      writable: true,
      value: void 0
    });

    _extensions.set(this, {
      writable: true,
      value: void 0
    });

    _extensionMap.set(this, {
      writable: true,
      value: void 0
    });

    _classPrivateFieldSet(this, _extensions, uniqueBy(this.createExtensions(), // Ensure that all the provided extensions are unique.
    extension => extension.constructor));

    _classPrivateFieldSet(this, _extensionMap, new Map()); // Create the extension map for retrieving extensions from the `Preset`


    var _iterator = _createForOfIteratorHelper$3(_classPrivateFieldGet(this, _extensions)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var extension = _step.value;

        _classPrivateFieldGet(this, _extensionMap).set(extension.constructor, extension);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  /**
   * Check if the type of this extension's constructor matches the type of the
   * provided constructor.
   */


  isOfType(Constructor) {
    return this.constructor === Constructor;
  }
  /**
   * Create the extensions which will be consumed by the preset.
   *
   * Since this method is called in the constructor it should always be created
   * as an instance method and not a property. Properties aren't available for
   * the call to the parent class.
   *
   * ```ts
   * class MyPreset extends Preset {
   *   // GOOD ✅
   *   createExtensions() {
   *     return [];
   *   }
   *
   *   // BAD ❌
   *   createExtensions = () => {
   *     return [];
   *   }
   * }
   * ```
   */


  /**
   * When there are duplicate extensions used within the editor the extension
   * manager will call this method and make sure all presets are using the same
   * instance of the `ExtensionConstructor`.
   */
  replaceExtension(constructor, extension) {
    if (_classPrivateFieldGet(this, _extensionMap).has(constructor)) {
      _classPrivateFieldGet(this, _extensionMap).set(constructor, extension);
    }
  }
  /**
   * Get an extension from the extension holder (either a preset or a manager)
   * that corresponds to the provided `Constructor`.
   *
   * @param Constructor - the extension constructor to find in the editor.
   *
   * @remarks
   *
   * This method will throw an error if the constructor doesn't exist.
   */


  getExtension(Constructor) {
    var extension = _classPrivateFieldGet(this, _extensionMap).get(Constructor); // Throws an error if attempting to get an extension which is not available
    // in this preset.


    !extension ? process.env.NODE_ENV !== "production" ? invariant(false, {
      code: ErrorConstant.INVALID_PRESET_EXTENSION,
      message: "'".concat(Constructor.name, "' does not exist within the preset: '").concat(this.name, "'")
    }) : invariant(false) : void 0;
    return extension;
  }
  /**
   * Pass a reference to the globally shared `ExtensionStore` for this extension.
   *
   * @remarks
   *
   * The extension store allows extensions to access important variables without
   * complicating their creator methods.
   *
   * ```ts
   * import { PlainExtension } from 'remirror/core';
   *
   * class Awesome extends PlainExtension {
   *   customMethod() {
   *     if (this.store.view.hasFocus()) {
   *       log('dance dance dance');
   *     }
   *   }
   * }
   * ```
   *
   * This should only be called by the `RemirrorManager`.
   *
   * @internal
   * @nonVirtual
   */


  setExtensionStore(store) {
    if (_classPrivateFieldGet(this, _extensionStore)) {
      return;
    }

    _classPrivateFieldSet(this, _extensionStore, store);
  }
  /**
   * Clone a preset.
   */


  clone() {
    for (var _len2 = arguments.length, parameters = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      parameters[_key2] = arguments[_key2];
    }

    return new this.constructor(...parameters);
  }

}

_defineProperty(Preset, "defaultOptions", {});

/**
 * Determines if the passed in value is a preset.
 *
 * @param value - the preset to check
 */
function isPreset(value) {
  return isRemirrorType(value) && isIdentifierOfType(value, RemirrorIdentifier.Preset);
}
/**
 * Determines if the passed in value is a preset constructor.
 *
 * @param value - the value to test
 */

function isPresetConstructor(value) {
  return isRemirrorType(value) && isIdentifierOfType(value, RemirrorIdentifier.PresetConstructor);
}
/**
 * Checks that the preset has a valid constructor with the `defaultOptions` and
 * `defaultOptions` defined as static properties.
 */

function isValidPresetConstructor(Constructor) {
  var code = ErrorConstant.INVALID_PRESET;
  !isPresetConstructor(Constructor) ? process.env.NODE_ENV !== "production" ? invariant(false, {
    message: 'This is not a valid extension constructor',
    code
  }) : invariant(false) : void 0;
  isValidConstructor(Constructor, code);
}
/**
 * Automatically infers whether the constructor parameter is required for the
 * Preset.
 *
 * - Required when any of the options are not optional.
 */

function _createForOfIteratorHelper$4(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray$4(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray$4(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$4(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$4(o, minLen); }

function _arrayLikeToArray$4(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/**
 * A decorator for the remirror extension.
 *
 * This adds static properties to the extension constructor.
 */
function extensionDecorator(options) {
  return ReadonlyConstructor => {
    var defaultOptions = options.defaultOptions,
        customHandlerKeys = options.customHandlerKeys,
        handlerKeys = options.handlerKeys,
        staticKeys = options.staticKeys,
        defaultPriority = options.defaultPriority,
        handlerKeyOptions = options.handlerKeyOptions,
        rest = _objectWithoutProperties(options, ["defaultOptions", "customHandlerKeys", "handlerKeys", "staticKeys", "defaultPriority", "handlerKeyOptions"]);

    var Constructor = Cast(ReadonlyConstructor);

    if (defaultOptions) {
      Constructor.defaultOptions = defaultOptions;
    }

    if (defaultPriority) {
      Constructor.defaultPriority = defaultPriority;
    }

    if (handlerKeyOptions) {
      Constructor.handlerKeyOptions = handlerKeyOptions;
    }

    Constructor.staticKeys = staticKeys !== null && staticKeys !== void 0 ? staticKeys : [];
    Constructor.handlerKeys = handlerKeys !== null && handlerKeys !== void 0 ? handlerKeys : [];
    Constructor.customHandlerKeys = customHandlerKeys !== null && customHandlerKeys !== void 0 ? customHandlerKeys : [];

    var _iterator = _createForOfIteratorHelper$4(entries(rest)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _step$value = _slicedToArray(_step.value, 2),
            key = _step$value[0],
            value = _step$value[1];

        if (Constructor[key]) {
          continue;
        }

        Constructor[key] = value;
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return Cast(Constructor);
  };
}

/**
 * A decorator for the remirror preset.
 *
 * This adds static properties to the preset constructor.
 */
function presetDecorator(options) {
  return ReadonlyConstructor => {
    var defaultOptions = options.defaultOptions,
        customHandlerKeys = options.customHandlerKeys,
        handlerKeys = options.handlerKeys,
        staticKeys = options.staticKeys;
    var Constructor = Cast(ReadonlyConstructor);

    if (defaultOptions) {
      Constructor.defaultOptions = defaultOptions;
    }

    Constructor.staticKeys = staticKeys !== null && staticKeys !== void 0 ? staticKeys : [];
    Constructor.handlerKeys = handlerKeys !== null && handlerKeys !== void 0 ? handlerKeys : [];
    Constructor.customHandlerKeys = customHandlerKeys !== null && customHandlerKeys !== void 0 ? customHandlerKeys : [];
    return Cast(Constructor);
  };
}

var _dec, _class, _transaction, _temp;

function _createForOfIteratorHelper$5(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray$5(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray$5(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$5(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$5(o, minLen); }

function _arrayLikeToArray$5(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var CommandsExtension = (_dec = /*#__PURE__*/extensionDecorator({
  defaultPriority: ExtensionPriority.Highest
}), /*#__PURE__*/_dec(_class = (_temp = (_transaction = /*#__PURE__*/new WeakMap(), class CommandsExtension extends PlainExtension {
  constructor() {
    var _this;

    super(...arguments);
    _this = this;

    _transaction.set(this, {
      writable: true,
      value: void 0
    });

    _defineProperty(this, "forceUpdate", function (tr) {
      for (var _len = arguments.length, keys = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        keys[_key - 1] = arguments[_key];
      }

      _this.setMeta(tr, ...keys);

      return tr;
    });

    _defineProperty(this, "getForcedUpdates", tr => {
      return this.getMeta(tr);
    });

    _defineProperty(this, "getChain", () => {
      var chain = this.store.getStoreKey('chain');
      !chain ? process.env.NODE_ENV !== "production" ? invariant(false, {
        code: ErrorConstant.COMMANDS_CALLED_IN_OUTER_SCOPE
      }) : invariant(false) : void 0;
      return chain;
    });

    _defineProperty(this, "getCommands", () => {
      var commands = this.store.getStoreKey('commands');
      !commands ? process.env.NODE_ENV !== "production" ? invariant(false, {
        code: ErrorConstant.COMMANDS_CALLED_IN_OUTER_SCOPE
      }) : invariant(false) : void 0;
      return commands;
    });
  }

  get name() {
    return 'commands';
  }
  /**
   * The current transaction which allows for making commands chainable.
   */


  get transaction() {
    var state = this.store.getState();

    if (!_classPrivateFieldGet(this, _transaction)) {
      _classPrivateFieldSet(this, _transaction, state.tr);
    }

    var isValid = _classPrivateFieldGet(this, _transaction).before.eq(state.doc);

    var hasSteps = !isEmptyArray(_classPrivateFieldGet(this, _transaction).steps);

    if (!isValid) {
      var _tr = state.tr;

      if (hasSteps) {
        var _iterator = _createForOfIteratorHelper$5(_classPrivateFieldGet(this, _transaction).steps),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var step = _step.value;

            _tr.step(step);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }

      _classPrivateFieldSet(this, _transaction, _tr);
    }

    return _classPrivateFieldGet(this, _transaction);
  }

  onCreate() {
    var _this$store = this.store,
        setExtensionStore = _this$store.setExtensionStore,
        setStoreKey = _this$store.setStoreKey; // Add the commands to the extension store

    setExtensionStore('getCommands', this.getCommands);
    setExtensionStore('getChain', this.getChain); // Support forced updates.

    setExtensionStore('forceUpdate', this.forceUpdate);
    setStoreKey('getForcedUpdates', this.getForcedUpdates); // Enable retrieval of the current transaction.

    setExtensionStore('getTransaction', () => this.transaction);
  }

  onView(view) {
    var commands = object();
    var names = new Set();
    var chained = object();
    var unchained = object();

    var _iterator2 = _createForOfIteratorHelper$5(this.store.extensions),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var extension = _step2.value;

        if (!extension.createCommands) {
          continue;
        }

        var extensionCommands = extension.createCommands();

        var _iterator4 = _createForOfIteratorHelper$5(entries(extensionCommands)),
            _step4;

        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var _step4$value = _slicedToArray(_step4.value, 2),
                name = _step4$value[0],
                command = _step4$value[1];

            throwIfNameNotUnique({
              name,
              set: names,
              code: ErrorConstant.DUPLICATE_COMMAND_NAMES
            });
            !!forbiddenNames.has(name) ? process.env.NODE_ENV !== "production" ? invariant(false, {
              code: ErrorConstant.DUPLICATE_COMMAND_NAMES,
              message: 'The command name you chose is forbidden.'
            }) : invariant(false) : void 0;
            unchained[name] = {
              name: extension.name,
              command: this.unchainedFactory({
                command
              }),
              isEnabled: this.unchainedFactory({
                command,
                shouldDispatch: false
              })
            };
            chained[name] = this.chainedFactory({
              command,
              chained
            });
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }

    var setStoreKey = this.store.setStoreKey;

    var _iterator3 = _createForOfIteratorHelper$5(entries(unchained)),
        _step3;

    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var _step3$value = _slicedToArray(_step3.value, 2),
            commandName = _step3$value[0],
            _step3$value$ = _step3$value[1],
            _command = _step3$value$.command,
            isEnabled = _step3$value$.isEnabled;

        commands[commandName] = _command;
        commands[commandName].isEnabled = isEnabled;
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }

    chained.run = () => view.dispatch(this.transaction);

    setStoreKey('commands', commands);
    setStoreKey('chain', chained);
  }
  /**
   * Update the cached transaction whenever the state is updated.
   */


  onStateUpdate(_ref) {
    var state = _ref.state;

    _classPrivateFieldSet(this, _transaction, state.tr);
  }
  /**
   * Create the default commands available to all extensions.
   */


  createCommands() {
    var _this2 = this;

    return {
      /**
       * Create a custom transaction.
       *
       * @param transactionUpdater - callback method for updating the
       * transaction in the editor. Since transactions are mutable there is no
       * return type.
       *
       * @remarks
       *
       * This is primarily intended for use within a chainable command chain.
       */
      customTransaction(transactionUpdater) {
        return (_ref2) => {
          var tr = _ref2.tr,
              dispatch = _ref2.dispatch;

          if (dispatch) {
            transactionUpdater(tr);
            dispatch(tr);
          }

          return true;
        };
      },

      /**
       * Insert text into the dom at the current location.
       */
      insertText(text) {
        return (_ref3) => {
          var tr = _ref3.tr,
              dispatch = _ref3.dispatch;

          if (dispatch) {
            dispatch(tr.insertText(text));
          }

          return true;
        };
      },

      /**
       * Delete the provided range or current selection.
       */
      delete(range) {
        return (_ref4) => {
          var tr = _ref4.tr,
              dispatch = _ref4.dispatch;

          var _ref5 = range !== null && range !== void 0 ? range : tr.selection,
              from = _ref5.from,
              to = _ref5.to;

          if (dispatch) {
            dispatch(tr.delete(from, to));
          }

          return true;
        };
      },

      /**
       * Fire an empty update to trigger an update to all decorations, and state
       * that may not yet have run.
       *
       * This can be used in extensions to when certain options that affect the
       * plugin state have updated.
       */
      emptyUpdate: () => {
        return (_ref6) => {
          var tr = _ref6.tr,
              dispatch = _ref6.dispatch;

          if (dispatch) {
            dispatch(tr);
          }

          return true;
        };
      },

      /**
       * Force an update of the specific
       */
      forceUpdate: function forceUpdate() {
        for (var _len2 = arguments.length, keys = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          keys[_key2] = arguments[_key2];
        }

        return (_ref7) => {
          var tr = _ref7.tr,
              dispatch = _ref7.dispatch;

          if (dispatch) {
            dispatch(_this2.forceUpdate(tr, ...keys));
          }

          return true;
        };
      },

      /**
       * Update the attributes for the node at the specified `pos` in the
       * editor.
       */
      updateNodeAttributes: (pos, attrs) => {
        return (_ref8) => {
          var tr = _ref8.tr,
              dispatch = _ref8.dispatch;

          if (dispatch) {
            dispatch(tr.setNodeMarkup(pos, undefined, attrs));
          }

          return true;
        };
      }
    };
  }
  /**
   * This plugin is here only to keep track of the forced updates meta data.
   */


  createPlugin() {
    return {};
  }
  /**
   * A helper for forcing through updates in the view layer. The view layer can
   * check for the meta data of the transaction with
   * `manager.store.getForcedUpdate(tr)`. If that has a value then it should use
   * the unique symbol to update the key.
   */


  getMeta(tr) {
    var _tr$getMeta;

    return (_tr$getMeta = tr.getMeta(this.pluginKey)) !== null && _tr$getMeta !== void 0 ? _tr$getMeta : [];
  }

  setMeta(tr) {
    var meta = this.getMeta(tr);

    for (var _len3 = arguments.length, keys = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
      keys[_key3 - 1] = arguments[_key3];
    }

    tr.setMeta(this.pluginKey, uniqueArray([...meta, ...keys]));
  }
  /**
   * Create an unchained command method.
   */


  unchainedFactory(parameter) {
    var _this3 = this;

    return function () {
      var _parameter$shouldDisp = parameter.shouldDispatch,
          shouldDispatch = _parameter$shouldDisp === void 0 ? true : _parameter$shouldDisp,
          command = parameter.command;
      var view = _this3.store.view;
      var state = view.state;
      var dispatch;

      if (shouldDispatch) {
        dispatch = view.dispatch; // TODO make this be configurable?

        view.focus();
      }

      return command(...arguments)({
        state,
        dispatch,
        view,
        tr: _this3.transaction
      });
    };
  }
  /**
   * Get the chainable commands.
   */


  /**
   * Create a chained command method.
   */
  chainedFactory(parameter) {
    var _this4 = this;

    return function () {
      var chained = parameter.chained,
          command = parameter.command;
      var view = _this4.store.view;
      var state = view.state;
      /** Dispatch should do nothing here except check transaction */

      var dispatch = transaction => {
        !(transaction === _this4.transaction) ? process.env.NODE_ENV !== "production" ? invariant(false, {
          message: 'Chaining currently only supports `CommandFunction` methods which do not use the `state.tr` property. Instead you should use the provided `tr` property.'
        }) : invariant(false) : void 0;
      };

      command(...arguments)({
        state,
        dispatch,
        view,
        tr: _this4.transaction
      });
      return chained;
    };
  }

}), _temp)) || _class);
/**
 * Provides the list of Prosemirror EditorView props that should be updated/
 */

/**
 * The names that are forbidden from being used as a command name.
 */
var forbiddenNames = /*#__PURE__*/new Set(['run', 'chain']);

var _dec$1, _class$1;

function _createForOfIteratorHelper$6(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray$6(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray$6(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$6(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$6(o, minLen); }

function _arrayLikeToArray$6(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var HelpersExtension = (_dec$1 = /*#__PURE__*/extensionDecorator({
  defaultPriority: ExtensionPriority.High
}), /*#__PURE__*/_dec$1(_class$1 = class HelpersExtension extends PlainExtension {
  get name() {
    return 'helpers';
  }
  /**
   * Provide a method with access to the helpers for use in commands and
   * helpers.
   */


  onCreate() {
    this.store.setExtensionStore('getHelpers', () => {
      var helpers = this.store.getStoreKey('helpers');
      !helpers ? process.env.NODE_ENV !== "production" ? invariant(false, {
        code: ErrorConstant.HELPERS_CALLED_IN_OUTER_SCOPE
      }) : invariant(false) : void 0;
      return helpers;
    });
  }
  /**
   * Helpers are only available once the view has been added to
   * `RemirrorManager`.
   */


  onView() {
    var _this = this;

    var helpers = object();
    var active = object();
    var names = new Set();

    var _iterator = _createForOfIteratorHelper$6(this.store.extensions),
        _step;

    try {
      var _loop = function _loop() {
        var extension = _step.value;

        if (isNodeExtension(extension)) {
          active[extension.name] = attrs => {
            return isNodeActive({
              state: _this.store.getState(),
              type: extension.type,
              attrs
            });
          };
        }

        if (isMarkExtension(extension)) {
          active[extension.name] = () => {
            return isMarkActive({
              stateOrTransaction: _this.store.getState(),
              type: extension.type
            });
          };
        }

        if (!extension.createHelpers) {
          return "continue";
        }

        var extensionHelpers = extension.createHelpers();

        var _iterator2 = _createForOfIteratorHelper$6(entries(extensionHelpers)),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var _step2$value = _slicedToArray(_step2.value, 2),
                name = _step2$value[0],
                helper = _step2$value[1];

            throwIfNameNotUnique({
              name,
              set: names,
              code: ErrorConstant.DUPLICATE_HELPER_NAMES
            });
            helpers[name] = helper;
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      };

      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _ret = _loop();

        if (_ret === "continue") continue;
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    this.store.setStoreKey('active', active);
    this.store.setStoreKey('helpers', helpers);
  }

  createHelpers() {
    return {};
  }

}) || _class$1);

var _dec$2, _class$2, _temp$1;

function _createForOfIteratorHelper$7(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray$7(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray$7(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$7(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$7(o, minLen); }

function _arrayLikeToArray$7(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
/**
 * This extension allows others extension to add the `createInputRules` method
 * for automatically transforming text when a certain regex pattern is typed.
 *
 * @remarks
 *
 * This is an example of adding custom functionality to an extension via the
 * `ExtensionParameterMethods`.
 *
 * @builtin
 */

var InputRulesExtension = (_dec$2 = /*#__PURE__*/extensionDecorator({
  defaultPriority: ExtensionPriority.High
}), /*#__PURE__*/_dec$2(_class$2 = (_temp$1 = class InputRulesExtension extends PlainExtension {
  constructor() {
    super(...arguments);

    _defineProperty(this, "rebuildInputRules", () => {
      var previousInputRules = this.inputRulesPlugin;
      this.loopExtensions();
      this.store.replacePlugin(previousInputRules, this.inputRulesPlugin);
      this.store.reconfigureStatePlugins();
    });
  }

  get name() {
    return 'inputRules';
  }

  /**
   * Ensure that all ssr transformers are run.
   */
  onCreate() {
    this.store.setExtensionStore('rebuildInputRules', this.rebuildInputRules);
    this.loopExtensions();
    this.store.addPlugins(this.inputRulesPlugin);
  }

  loopExtensions() {
    var rules = [];

    var _iterator = _createForOfIteratorHelper$7(this.store.extensions),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _this$store$managerSe, _extension$options$ex;

        var extension = _step.value;

        if ( // managerSettings excluded this from running
        ((_this$store$managerSe = this.store.managerSettings.exclude) === null || _this$store$managerSe === void 0 ? void 0 : _this$store$managerSe.inputRules) || // Method doesn't exist
        !extension.createInputRules || ( // Extension settings exclude it
        (_extension$options$ex = extension.options.exclude) === null || _extension$options$ex === void 0 ? void 0 : _extension$options$ex.inputRules)) {
          continue;
        }

        rules.push(...extension.createInputRules());
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    this.inputRulesPlugin = inputRules({
      rules
    });
  }
  /**
   * The method for rebuilding all the input rules.
   *
   * 1. Rebuild inputRules.
   * 2. Replace the old input rules plugin.
   * 3. Update the plugins used in the state (triggers an editor update).
   */


}, _temp$1)) || _class$2);

var _dec$3, _class$3, _temp$2;

function _createForOfIteratorHelper$8(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray$8(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray$8(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$8(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$8(o, minLen); }

function _arrayLikeToArray$8(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var KeymapExtension = (_dec$3 = /*#__PURE__*/extensionDecorator({
  defaultPriority: ExtensionPriority.Low,
  defaultOptions: {
    undoInputRuleOnBackspace: true,
    selectParentNodeOnEscape: false,
    excludeBaseKeymap: false
  },
  customHandlerKeys: ['keymap']
}), /*#__PURE__*/_dec$3(_class$3 = (_temp$2 = class KeymapExtension extends PlainExtension {
  constructor() {
    super(...arguments);

    _defineProperty(this, "baseKeyBindings", object());

    _defineProperty(this, "extraKeyBindings", []);

    _defineProperty(this, "rebuildKeymap", () => {
      var previousKeymap = this.keymap;
      this.loopExtensions();
      this.store.replacePlugin(previousKeymap, this.keymap);
      this.store.reconfigureStatePlugins();
    });

    _defineProperty(this, "createKeymap", () => {
      this.createBaseKeymap();
      return this.buildKeymap();
    });

    _defineProperty(this, "onAddCustomHandler", (_ref) => {
      var _this$store$rebuildKe, _this$store;

      var keymap = _ref.keymap;

      if (!keymap) {
        return;
      }

      this.extraKeyBindings = [...this.extraKeyBindings, keymap];
      (_this$store$rebuildKe = (_this$store = this.store).rebuildKeymap) === null || _this$store$rebuildKe === void 0 ? void 0 : _this$store$rebuildKe.call(_this$store);
      return () => {
        var _this$store$rebuildKe2, _this$store2;

        this.extraKeyBindings = this.extraKeyBindings.filter(binding => binding !== keymap);
        (_this$store$rebuildKe2 = (_this$store2 = this.store).rebuildKeymap) === null || _this$store$rebuildKe2 === void 0 ? void 0 : _this$store$rebuildKe2.call(_this$store2);
      };
    });
  }

  get name() {
    return 'keymap';
  }
  /**
   * The base keybinding which will be generated from the provided properties.
   */


  /**
   * This adds the `createKeymap` method functionality to all extensions.
   */
  onCreate() {
    this.store.setExtensionStore('rebuildKeymap', this.rebuildKeymap);
    this.loopExtensions();
    this.store.addPlugins(this.keymap);
  }
  /**
   * Updates the stored keymap plugin on this extension.
   */


  loopExtensions() {
    var extensionKeymaps = [];

    var _iterator = _createForOfIteratorHelper$8(this.store.extensions),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _this$store$managerSe, _extension$options$ex;

        var extension = _step.value;

        // Ignore this extension when.
        if ( // The user doesn't want any keymaps in the editor.
        ((_this$store$managerSe = this.store.managerSettings.exclude) === null || _this$store$managerSe === void 0 ? void 0 : _this$store$managerSe.keymap) || // The extension doesn't have the `createKeymap` method.
        !extension.createKeymap || ( // The extension was configured to ignore the keymap.
        (_extension$options$ex = extension.options.exclude) === null || _extension$options$ex === void 0 ? void 0 : _extension$options$ex.keymap)) {
          continue;
        }

        extensionKeymaps.push(extension.createKeymap());
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    var mappedCommands = mergeProsemirrorKeyBindings(extensionKeymaps);
    this.keymap = keymap(mappedCommands);
  }
  /**
   * The method for rebuilding all the extension keymaps.
   *
   * 1. Rebuild keymaps.
   * 2. Replace the old keymap plugin.
   * 3. Update the plugins used in the state (triggers an editor update).
   */


  /**
   * Handle changes in the dynamic properties.
   */
  onSetOptions(parameter) {
    var changes = parameter.changes;
    var shouldReconfigureBindings = false;

    if (changes.excludeBaseKeymap.changed || changes.selectParentNodeOnEscape.changed || changes.undoInputRuleOnBackspace.changed) {
      shouldReconfigureBindings = true;
    }

    if (shouldReconfigureBindings) {
      var _this$store3, _this$store3$rebuildK;

      (_this$store3 = this.store) === null || _this$store3 === void 0 ? void 0 : (_this$store3$rebuildK = _this$store3.rebuildKeymap) === null || _this$store3$rebuildK === void 0 ? void 0 : _this$store3$rebuildK.call(_this$store3);
    }
  }

  createBaseKeymap() {
    var _this$options = this.options,
        selectParentNodeOnEscape = _this$options.selectParentNodeOnEscape,
        undoInputRuleOnBackspace = _this$options.undoInputRuleOnBackspace,
        excludeBaseKeymap = _this$options.excludeBaseKeymap;
    this.baseKeyBindings = object(); // Only add the base keymap if it is **NOT** excluded.

    if (!excludeBaseKeymap) {
      var _iterator2 = _createForOfIteratorHelper$8(entries(baseKeymap)),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _step2$value = _slicedToArray(_step2.value, 2),
              key = _step2$value[0],
              value = _step2$value[1];

          this.baseKeyBindings[key] = convertCommand(value);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    } // Automatically remove the input rule when the option is set to true.


    if (undoInputRuleOnBackspace) {
      this.baseKeyBindings.Backspace = convertCommand(chainCommands(undoInputRule, baseKeymap.Backspace));
    } // Allow escape to select the parent node when set to true.


    if (selectParentNodeOnEscape) {
      this.baseKeyBindings.Escape = convertCommand(selectParentNode);
    }
  }

  buildKeymap() {
    return mergeKeyBindings([...this.extraKeyBindings, this.baseKeyBindings]);
  }

}, _temp$2)) || _class$3);

function _createForOfIteratorHelper$9(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray$9(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray$9(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$9(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$9(o, minLen); }

function _arrayLikeToArray$9(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/**
 * This extension allows others extension to add the `createNodeView` method
 * for creating nodeViews which alter how the dom is rendered for the node.
 *
 * @remarks
 *
 * This is an example of adding custom functionality to an extension via the
 * `ExtensionParameterMethods`.
 *
 * @builtin
 */
class NodeViewsExtension extends PlainExtension {
  get name() {
    return 'nodeView';
  }
  /**
   * Ensure that all SSR transformers are run.
   */


  onCreate() {
    var nodeViewList = [];
    var nodeViews = object();

    var _iterator = _createForOfIteratorHelper$9(this.store.extensions),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _this$store$managerSe, _extension$options$ex;

        var extension = _step.value;

        if ( // managerSettings excluded this from running
        ((_this$store$managerSe = this.store.managerSettings.exclude) === null || _this$store$managerSe === void 0 ? void 0 : _this$store$managerSe.nodeViews) || // Method doesn't exist
        !extension.createNodeViews || ( // Extension settings exclude it
        (_extension$options$ex = extension.options.exclude) === null || _extension$options$ex === void 0 ? void 0 : _extension$options$ex.nodeViews)) {
          continue;
        }

        var _nodeView = extension.createNodeViews(); // `.unshift` ensures higher priority extensions can overwrite the lower
        // priority nodeViews.


        nodeViewList.unshift(isFunction(_nodeView) ? {
          [extension.name]: _nodeView
        } : _nodeView);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    for (var _i = 0, _nodeViewList = nodeViewList; _i < _nodeViewList.length; _i++) {
      var nodeView = _nodeViewList[_i];
      Object.assign(nodeViews, nodeView);
    }

    this.store.setStoreKey('nodeViews', nodeViews);
  }

}

function _createForOfIteratorHelper$a(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray$a(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray$a(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$a(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$a(o, minLen); }

function _arrayLikeToArray$a(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
/**
 * This extension allows others extension to add the `createPasteRules` method
 * for automatically transforming pasted text which matches a certain regex
 * pattern in the dom.
 *
 * @builtin
 */

class PasteRulesExtension extends PlainExtension {
  get name() {
    return 'pasteRules';
  }
  /**
   * Ensure that all ssr transformers are run.
   */


  onCreate() {
    var pasteRules = [];

    var _iterator = _createForOfIteratorHelper$a(this.store.extensions),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _this$store$managerSe, _extension$options$ex;

        var extension = _step.value;

        if ( // managerSettings excluded this from running
        ((_this$store$managerSe = this.store.managerSettings.exclude) === null || _this$store$managerSe === void 0 ? void 0 : _this$store$managerSe.pasteRules) || // Method doesn't exist
        !extension.createPasteRules || ( // Extension settings exclude it
        (_extension$options$ex = extension.options.exclude) === null || _extension$options$ex === void 0 ? void 0 : _extension$options$ex.pasteRules)) {
          continue;
        }

        pasteRules.push(...extension.createPasteRules());
      } // TODO rewrite so this is all one plugin

    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    this.store.addPlugins(...pasteRules);
  }

}

var _dec$4, _class$4, _plugins, _temp$3;

function ownKeys$3(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$3(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$3(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$3(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createForOfIteratorHelper$b(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray$b(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray$b(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$b(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$b(o, minLen); }

function _arrayLikeToArray$b(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var PluginsExtension = (_dec$4 = /*#__PURE__*/extensionDecorator({
  defaultPriority: ExtensionPriority.Highest
}), /*#__PURE__*/_dec$4(_class$4 = (_temp$3 = (_plugins = /*#__PURE__*/new WeakMap(), class PluginsExtension extends PlainExtension {
  constructor() {
    var _this;

    super(...arguments);
    _this = this;

    _plugins.set(this, {
      writable: true,
      value: []
    });

    _defineProperty(this, "pluginKeys", object());

    _defineProperty(this, "stateGetters", new Map());

    _defineProperty(this, "getPluginStateCreator", (key, extension) => state => {
      !(this.store.phase >= ManagerPhase.EditorView || state) ? process.env.NODE_ENV !== "production" ? invariant(false, {
        code: ErrorConstant.MANAGER_PHASE_ERROR,
        message: "The 'getPluginState' method of '".concat(extension.constructor.name, "' must be called with a current state if called before the 'view' has been added to the manager.")
      }) : invariant(false) : void 0;
      return getPluginState(key, state !== null && state !== void 0 ? state : this.store.getState());
    });

    _defineProperty(this, "getStateByName", identifier => {
      var stateGetter = this.stateGetters.get(identifier);
      !stateGetter ? process.env.NODE_ENV !== "production" ? invariant(false, {
        message: 'No plugin exists for the requested extension name.'
      }) : invariant(false) : void 0;
      return stateGetter();
    });

    _defineProperty(this, "addPlugins", function () {
      for (var _len = arguments.length, plugins = new Array(_len), _key = 0; _key < _len; _key++) {
        plugins[_key] = arguments[_key];
      }

      _classPrivateFieldSet(_this, _plugins, [..._classPrivateFieldGet(_this, _plugins), ...plugins]);

      _this.store.setStoreKey('plugins', _classPrivateFieldGet(_this, _plugins));
    });

    _defineProperty(this, "replacePlugin", (original, replacement) => {
      _classPrivateFieldSet(this, _plugins, _classPrivateFieldGet(this, _plugins).map(plugin => plugin === original ? replacement : plugin));

      this.store.setStoreKey('plugins', _classPrivateFieldGet(this, _plugins));
    });

    _defineProperty(this, "updateExtensionPlugins", extension => {
      this.extractExtensionPlugins(extension);
      this.store.setStoreKey('plugins', _classPrivateFieldGet(this, _plugins));
    });

    _defineProperty(this, "reconfigureStatePlugins", () => {
      !(this.store.phase >= ManagerPhase.EditorView) ? process.env.NODE_ENV !== "production" ? invariant(false, {
        code: ErrorConstant.MANAGER_PHASE_ERROR,
        message: '`reconfigureStatePlugins` should only be called after the view has been added to the manager.'
      }) : invariant(false) : void 0;
      var _this$store = this.store,
          view = _this$store.view,
          updateState = _this$store.updateState;
      var newState = view.state.reconfigure({
        plugins: _classPrivateFieldGet(this, _plugins)
      });
      updateState(newState);
    });
  }

  get name() {
    return 'plugins';
  }
  /**
   * All plugins created by other extension as well.
   */


  // Here set the plugins keys and state getters for retrieving plugin state.
  // These methods are later used.
  onCreate() {
    var _this$store2 = this.store,
        setStoreKey = _this$store2.setStoreKey,
        setExtensionStore = _this$store2.setExtensionStore;
    this.updateExtensionStore();

    var _iterator = _createForOfIteratorHelper$b(this.store.extensions),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _extension = _step.value;
        this.extractExtensionPlugins(_extension);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    setStoreKey('pluginKeys', this.pluginKeys);
    setStoreKey('getPluginState', this.getStateByName);
    setExtensionStore('getPluginState', this.getStateByName);
  }
  /**
   * Get all the plugins from the extension.
   */


  extractExtensionPlugins(extension) {
    var _this$store$managerSe, _extension$options$ex;

    var isNotPluginCreator = !extension.createPlugin && !extension.createExternalPlugins;

    if (isNotPluginCreator || ( // the manager settings don't exclude plugins
    (_this$store$managerSe = this.store.managerSettings.exclude) === null || _this$store$managerSe === void 0 ? void 0 : _this$store$managerSe.plugins) || ( // The extension settings don't exclude plugins
    (_extension$options$ex = extension.options.exclude) === null || _extension$options$ex === void 0 ? void 0 : _extension$options$ex.plugins)) {
      return;
    } // Create the custom plugin if it exists.


    if (extension.createPlugin) {
      var key = new PluginKey(extension.name); // Assign the plugin key to the extension name.

      this.pluginKeys[extension.name] = key;
      var getter = this.getPluginStateCreator(key, extension);
      extension.pluginKey = key;
      extension.constructor.prototype.getPluginState = getter;
      this.stateGetters.set(extension.name, getter);
      this.stateGetters.set(extension.constructor, getter);

      var pluginSpec = _objectSpread$3(_objectSpread$3({}, extension.createPlugin()), {}, {
        key
      });

      var plugin = new Plugin(pluginSpec);
      this.addOrReplacePlugins([plugin], extension.plugin ? [extension.plugin] : undefined);
      extension.plugin = plugin;
    }

    if (extension.createExternalPlugins) {
      var externalPlugins = extension.createExternalPlugins();
      this.addOrReplacePlugins(externalPlugins, extension.externalPlugins);
      extension.externalPlugins = externalPlugins;
    }
  }

  /**
   * Add or replace a plugin.
   */
  addOrReplacePlugins(plugins, previous) {
    // This is the first time plugins are being added.
    if (!previous || isEmptyArray(previous)) {
      _classPrivateFieldSet(this, _plugins, [..._classPrivateFieldGet(this, _plugins), ...plugins]);

      return;
    } // The number of plugins and previous plugins is different.


    if (plugins.length !== previous.length) {
      // Remove previous plugins and add the new plugins to the end.
      _classPrivateFieldSet(this, _plugins, [..._classPrivateFieldGet(this, _plugins).filter(plugin => !previous.includes(plugin)), ...plugins]);

      return;
    } // The length of plugins is identical, therefore a replacement is possible.


    var pluginMap = new Map();

    for (var _i = 0, _Object$entries = Object.entries(plugins); _i < _Object$entries.length; _i++) {
      var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
          index = _Object$entries$_i[0],
          plugin = _Object$entries$_i[1];

      pluginMap.set(previous[Number.parseInt(index, 10)], plugin);
    }

    _classPrivateFieldSet(this, _plugins, _classPrivateFieldGet(this, _plugins).map(plugin => {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      return previous.includes(plugin) ? pluginMap.get(plugin) : plugin;
    }));
  } // Method for retrieving the plugin state by the extension name.


  /**
   * Add the plugin specific properties and methods to the manager and extension store.
   */
  updateExtensionStore() {
    var _this$store3 = this.store,
        setStoreKey = _this$store3.setStoreKey,
        setExtensionStore = _this$store3.setExtensionStore; // Set the list of plugins on the manager store.

    setStoreKey('plugins', []); // Allow adding, replacing and removing plugins by other extensions.

    setExtensionStore('addPlugins', this.addPlugins);
    setExtensionStore('replacePlugin', this.replacePlugin);
    setExtensionStore('addOrReplacePlugins', this.addOrReplacePlugins);
    setExtensionStore('updateExtensionPlugins', this.updateExtensionPlugins);
    setExtensionStore('reconfigureStatePlugins', this.reconfigureStatePlugins);
  }
  /**
   * Adds a plugin to the list of plugins.
   */


}), _temp$3)) || _class$4);

var _dec$5, _class$5;

function ownKeys$4(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$4(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$4(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$4(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createForOfIteratorHelper$c(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray$c(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray$c(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$c(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$c(o, minLen); }

function _arrayLikeToArray$c(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var SchemaExtension = (_dec$5 = /*#__PURE__*/extensionDecorator({
  defaultPriority: ExtensionPriority.Highest
}), /*#__PURE__*/_dec$5(_class$5 = class SchemaExtension extends PlainExtension {
  get name() {
    return 'schema';
  }

  onCreate() {
    var managerSettings = this.store.managerSettings;
    var nodes = object();
    var marks = object();
    var namedExtraAttributes = transformExtraAttributes({
      settings: managerSettings,
      gatheredSchemaAttributes: this.gatherExtraAttributes(this.store.extensions),
      nodeNames: this.store.nodeNames,
      markNames: this.store.markNames
    }); // Skip the for loop by setting the list to empty when extra attributes are
    // disabled

    var _iterator = _createForOfIteratorHelper$c(this.store.extensions),
        _step;

    try {
      var _loop = function _loop() {
        var _namedExtraAttributes, _extension$options$ex;

        var extension = _step.value;
        var currentAttributes = (_namedExtraAttributes = namedExtraAttributes[extension.name]) !== null && _namedExtraAttributes !== void 0 ? _namedExtraAttributes : object();
        namedExtraAttributes[extension.name] = _objectSpread$4(_objectSpread$4({}, currentAttributes), (_extension$options$ex = extension.options.extraAttributes) !== null && _extension$options$ex !== void 0 ? _extension$options$ex : object());
        var ignoreExtraAttributes = managerSettings.disableExtraAttributes === true || extension.options.disableExtraAttributes === true || extension.constructor.disableExtraAttributes === true;

        if (isNodeExtension(extension)) {
          var spec = createSpec({
            createExtensionSpec: extra => extension.createNodeSpec(extra),
            extraAttributes: namedExtraAttributes[extension.name],
            ignoreExtraAttributes,
            name: extension.constructor.name
          });
          extension.spec = spec;
          nodes[extension.name] = spec;
        }

        if (isMarkExtension(extension)) {
          var _spec = createSpec({
            createExtensionSpec: extra => extension.createMarkSpec(extra),
            extraAttributes: namedExtraAttributes[extension.name],
            ignoreExtraAttributes,
            name: extension.constructor.name
          });

          extension.spec = _spec;
          marks[extension.name] = _spec;
        }
      };

      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    var schema = new Schema({
      nodes,
      marks
    });
    this.store.setStoreKey('nodes', nodes);
    this.store.setStoreKey('marks', marks);
    this.store.setStoreKey('schema', schema);
    this.store.setExtensionStore('schema', schema);
  }
  /**
   * Gather all the extra attributes that have been added by extensions.
   */


  gatherExtraAttributes(extensions) {
    var extraSchemaAttributes = [];

    var _iterator2 = _createForOfIteratorHelper$c(extensions),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var extension = _step2.value;

        if (!extension.createSchemaAttributes) {
          continue;
        }

        extraSchemaAttributes.push(...extension.createSchemaAttributes());
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }

    return extraSchemaAttributes;
  }

}) || _class$5);
/**
 * The extra identifiers that can be used.
 */

/**
 * Get the extension extra attributes
 */
function transformExtraAttributes(_ref) {
  var _settings$extraAttrib;

  var settings = _ref.settings,
      gatheredExtraAttributes = _ref.gatheredSchemaAttributes,
      nodeNames = _ref.nodeNames,
      markNames = _ref.markNames;
  var extraAttributes = object();

  if (settings.disableExtraAttributes) {
    return extraAttributes;
  }

  var extraSchemaAttributes = [...gatheredExtraAttributes, ...((_settings$extraAttrib = settings.extraAttributes) !== null && _settings$extraAttrib !== void 0 ? _settings$extraAttrib : [])];

  for (var _i = 0, _arr = extraSchemaAttributes !== null && extraSchemaAttributes !== void 0 ? extraSchemaAttributes : []; _i < _arr.length; _i++) {
    var attributeGroup = _arr[_i];
    var identifiers = getIdentifiers({
      identifiers: attributeGroup.identifiers,
      nodeNames,
      markNames
    });

    var _iterator3 = _createForOfIteratorHelper$c(identifiers),
        _step3;

    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var _extraAttributes$iden;

        var identifier = _step3.value;
        var currentValue = (_extraAttributes$iden = extraAttributes[identifier]) !== null && _extraAttributes$iden !== void 0 ? _extraAttributes$iden : {};
        extraAttributes[identifier] = _objectSpread$4(_objectSpread$4({}, currentValue), attributeGroup.attributes);
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
  }

  return extraAttributes;
}

function getIdentifiers(parameter) {
  var identifiers = parameter.identifiers,
      nodeNames = parameter.nodeNames,
      markNames = parameter.markNames;

  if (isArray(identifiers)) {
    return identifiers;
  }

  switch (identifiers) {
    case 'nodes':
      return nodeNames;

    case 'marks':
      return markNames;

    default:
      return [...nodeNames, ...markNames];
  }
}

function createSpec(parameter) {
  var createExtensionSpec = parameter.createExtensionSpec,
      extraAttributes = parameter.extraAttributes,
      ignoreExtraAttributes = parameter.ignoreExtraAttributes,
      name = parameter.name;
  var defaultsCalled = false;
  var defaults = createDefaults(extraAttributes, ignoreExtraAttributes, () => {
    defaultsCalled = true;
  });
  var parse = createParseDOM(extraAttributes, ignoreExtraAttributes);
  var dom = createToDOM(extraAttributes, ignoreExtraAttributes);
  var spec = createExtensionSpec({
    defaults,
    parse,
    dom
  });
  !(ignoreExtraAttributes || defaultsCalled) ? process.env.NODE_ENV !== "production" ? invariant(false, {
    code: ErrorConstant.EXTENSION_SPEC,
    message: "When creating a node specification you must call the 'defaults', and parse, and 'dom' methods. To avoid this error you can set the static property 'disableExtraAttributes' of '".concat(name, "' to 'true'.")
  }) : invariant(false) : void 0;
  return spec;
}
/**
 * Get the value of the extra attribute as an object.
 */


function getExtraAttributesObject(value) {
  if (isString(value)) {
    return {
      default: value
    };
  }

  !value ? process.env.NODE_ENV !== "production" ? invariant(false, {
    message: "".concat(toString(value), " is not supported"),
    code: ErrorConstant.EXTENSION_EXTRA_ATTRIBUTES
  }) : invariant(false) : void 0;
  return value;
}
/**
 * Create the `defaults()` method which is used for setting the property.
 */


function createDefaults(extraAttributes, shouldIgnore, onCalled) {
  // Store all the default attributes here.
  return () => {
    onCalled();
    var attributes = object();

    if (shouldIgnore) {
      return attributes;
    } // Loop through the extra attributes and attach to the attributes object.


    var _iterator4 = _createForOfIteratorHelper$c(entries(extraAttributes)),
        _step4;

    try {
      for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
        var _value$default;

        var _step4$value = _slicedToArray(_step4.value, 2),
            name = _step4$value[0],
            config = _step4$value[1];

        var value = getExtraAttributesObject(config);
        attributes[name] = {
          default: (_value$default = value.default) !== null && _value$default !== void 0 ? _value$default : null
        };
      }
    } catch (err) {
      _iterator4.e(err);
    } finally {
      _iterator4.f();
    }

    return attributes;
  };
}
/**
 * Create the parseDOM method to be applied to the extension `createNodeSpec`.
 */


function createParseDOM(extraAttributes, shouldIgnore) {
  return domNode => {
    var attributes = object();

    if (shouldIgnore) {
      return attributes;
    }

    var _iterator5 = _createForOfIteratorHelper$c(entries(extraAttributes)),
        _step5;

    try {
      for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
        var _domNode$getAttribute2;

        var _step5$value = _slicedToArray(_step5.value, 2),
            name = _step5$value[0],
            config = _step5$value[1];

        var _getExtraAttributesOb = getExtraAttributesObject(config),
            parseDOM = _getExtraAttributesOb.parseDOM,
            other = _objectWithoutProperties(_getExtraAttributesOb, ["parseDOM"]);

        if (!isElementDomNode(domNode)) {
          continue;
        }

        if (isNullOrUndefined(parseDOM)) {
          var _domNode$getAttribute;

          attributes[name] = (_domNode$getAttribute = domNode.getAttribute(name)) !== null && _domNode$getAttribute !== void 0 ? _domNode$getAttribute : other.default;
          continue;
        }

        if (isFunction(parseDOM)) {
          var _parseDOM;

          attributes[name] = (_parseDOM = parseDOM(domNode)) !== null && _parseDOM !== void 0 ? _parseDOM : other.default;
          continue;
        }

        attributes[name] = (_domNode$getAttribute2 = domNode.getAttribute(parseDOM)) !== null && _domNode$getAttribute2 !== void 0 ? _domNode$getAttribute2 : other.default;
      }
    } catch (err) {
      _iterator5.e(err);
    } finally {
      _iterator5.f();
    }

    return attributes;
  };
}
/**
 * Create the `toDOM` method to be applied to the extension `createNodeSpec`.
 */


function createToDOM(extraAttributes, shouldIgnore) {
  return item => {
    var domAttributes = object();

    if (shouldIgnore) {
      return domAttributes;
    }

    function updateDomAttributes(value, name) {
      if (isString(value)) {
        domAttributes[name] = value;
      }

      if (isArray(value)) {
        var _value$;

        domAttributes[value[0]] = (_value$ = value[1]) !== null && _value$ !== void 0 ? _value$ : item.attrs[name];
      }

      return;
    }

    var _iterator6 = _createForOfIteratorHelper$c(entries(extraAttributes)),
        _step6;

    try {
      for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
        var _step6$value = _slicedToArray(_step6.value, 2),
            name = _step6$value[0],
            config = _step6$value[1];

        var _getExtraAttributesOb2 = getExtraAttributesObject(config),
            toDOM = _getExtraAttributesOb2.toDOM,
            parseDOM = _getExtraAttributesOb2.parseDOM;

        if (isNullOrUndefined(toDOM)) {
          var key = isString(parseDOM) ? parseDOM : name;
          domAttributes[key] = item.attrs[name];
          continue;
        }

        if (isFunction(toDOM)) {
          updateDomAttributes(toDOM(item.attrs, getNodeMarkOptions(item)), name);
          continue;
        }

        updateDomAttributes(toDOM, name);
      }
    } catch (err) {
      _iterator6.e(err);
    } finally {
      _iterator6.f();
    }

    return domAttributes;
  };
}
/**
 * Get the options object which applies should be used to obtain the node or
 * mark type.
 */


function getNodeMarkOptions(item) {
  if (isProsemirrorNode(item)) {
    return {
      node: item
    };
  }

  if (isProsemirrorMark(item)) {
    return {
      mark: item
    };
  }

  return {};
}

var _dec$6, _class$6, _temp$4;

function _createForOfIteratorHelper$d(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray$d(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray$d(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$d(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$d(o, minLen); }

function _arrayLikeToArray$d(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var SuggestExtension = (_dec$6 = /*#__PURE__*/extensionDecorator({
  customHandlerKeys: ['suggester']
}), /*#__PURE__*/_dec$6(_class$6 = (_temp$4 = class SuggestExtension extends PlainExtension {
  constructor() {
    super(...arguments);

    _defineProperty(this, "onCreate", () => {
      var suggesters = [];

      var _iterator = _createForOfIteratorHelper$d(this.store.extensions),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _this$store$managerSe, _extension$options$ex;

          var extension = _step.value;

          if ( // Manager settings excluded this from running
          ((_this$store$managerSe = this.store.managerSettings.exclude) === null || _this$store$managerSe === void 0 ? void 0 : _this$store$managerSe.suggesters) || // Method doesn't exist
          !extension.createSuggesters || ( // Extension settings exclude it from running
          (_extension$options$ex = extension.options.exclude) === null || _extension$options$ex === void 0 ? void 0 : _extension$options$ex.suggesters)) {
            continue;
          }

          var suggester = extension.createSuggesters();
          var suggesterList = isArray(suggester) ? suggester : [suggester];
          suggesters.push(...suggesterList);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      this.store.addPlugins(suggest(...suggesters));
    });

    _defineProperty(this, "onAddCustomHandler", (_ref) => {
      var suggester = _ref.suggester;

      if (!suggester) {
        return;
      } // Update the suggesters with the provided suggester. Returns the cleanup
      // method.


      return addSuggester(this.store.getState(), suggester);
    });
  }

  get name() {
    return 'suggestions';
  }
  /**
   * Ensure that all ssr transformers are run.
   */


  createHelpers() {
    return {
      /**
       * Get the suggest plugin state.
       */
      getSuggestPluginState: () => this.getSuggestPluginState(),

      /**
       * Get some helpful methods from the SuggestPluginState.
       */
      getSuggestPluginHelpers: () => {
        var _this$getSuggestPlugi = this.getSuggestPluginState(),
            addIgnored = _this$getSuggestPlugi.addIgnored,
            clearIgnored = _this$getSuggestPlugi.clearIgnored,
            removeIgnored = _this$getSuggestPlugi.removeIgnored,
            ignoreNextExit = _this$getSuggestPlugi.ignoreNextExit,
            setMarkRemoved = _this$getSuggestPlugi.setMarkRemoved;

        return {
          addIgnored,
          clearIgnored,
          removeIgnored,
          ignoreNextExit,
          setMarkRemoved
        };
      }
    };
  }

  getSuggestPluginState() {
    return getSuggestPluginState(this.store.getState());
  }

}, _temp$4)) || _class$6);

var _dec$7, _class$7, _generalTags, _markTags, _nodeTags, _temp$5;

function _createForOfIteratorHelper$e(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray$e(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray$e(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$e(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$e(o, minLen); }

function _arrayLikeToArray$e(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var TagsExtension = (_dec$7 = /*#__PURE__*/extensionDecorator({
  defaultPriority: ExtensionPriority.Highest
}), /*#__PURE__*/_dec$7(_class$7 = (_temp$5 = (_generalTags = /*#__PURE__*/new WeakMap(), _markTags = /*#__PURE__*/new WeakMap(), _nodeTags = /*#__PURE__*/new WeakMap(), class TagsExtension extends PlainExtension {
  constructor() {
    super(...arguments);

    _generalTags.set(this, {
      writable: true,
      value: object()
    });

    _markTags.set(this, {
      writable: true,
      value: object()
    });

    _nodeTags.set(this, {
      writable: true,
      value: object()
    });
  }

  get name() {
    return 'tags';
  }

  get combinedTags() {
    return {
      general: _classPrivateFieldGet(this, _generalTags),
      mark: _classPrivateFieldGet(this, _markTags),
      node: _classPrivateFieldGet(this, _nodeTags)
    };
  }

  onCreate() {
    this.resetTags();

    var _iterator = _createForOfIteratorHelper$e(this.store.extensions),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var extension = _step.value;
        this.updateTagForExtension(extension);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    this.store.setStoreKey('tags', this.combinedTags);
    this.store.setExtensionStore('tags', this.combinedTags);
  }

  resetTags() {
    _classPrivateFieldSet(this, _generalTags, {
      [ExtensionTag.FormattingMark]: [],
      [ExtensionTag.FormattingNode]: [],
      [ExtensionTag.LastNodeCompatible]: [],
      [ExtensionTag.NodeCursor]: []
    });

    _classPrivateFieldSet(this, _markTags, {
      [MarkGroup.Alignment]: [],
      [MarkGroup.Behavior]: [],
      [MarkGroup.Color]: [],
      [MarkGroup.FontStyle]: [],
      [MarkGroup.Indentation]: [],
      [MarkGroup.Link]: [],
      [MarkGroup.Code]: []
    });

    _classPrivateFieldSet(this, _nodeTags, {
      [NodeGroup.Block]: [],
      [NodeGroup.Inline]: []
    });
  }

  updateTagForExtension(extension) {
    if (isNodeExtension(extension)) {
      var group = extension.spec.group;
      var name = extension.name;
      _classPrivateFieldGet(this, _nodeTags)[group] = isUndefined(_classPrivateFieldGet(this, _nodeTags)[group]) ? [name] : [..._classPrivateFieldGet(this, _nodeTags)[group], name];
    }

    if (isMarkExtension(extension)) {
      var _group = extension.spec.group;
      var _name = extension.name;
      _classPrivateFieldGet(this, _markTags)[_group] = isUndefined(_classPrivateFieldGet(this, _markTags)[_group]) ? [_name] : [..._classPrivateFieldGet(this, _markTags)[_group], _name];
    }

    if (!extension.tags) {
      return;
    }

    var _iterator2 = _createForOfIteratorHelper$e(extension.tags),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var tag = _step2.value;

        var generalTag = _classPrivateFieldGet(this, _generalTags)[tag];

        _classPrivateFieldGet(this, _generalTags)[tag] = isUndefined(generalTag) ? [extension.name] : [...generalTag, extension.name];
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }

}), _temp$5)) || _class$7);

/**
 * Provides all the builtin extensions to the editor.
 *
 * @remarks
 *
 * This is used automatically and (at the time of writing) can't be removed from
 * the editor. If you feel that there's a compelling reason to override these
 * extensions feel free to open an [issue
 * here](https://github.com/remirror/remirror/issues) and it can be addressed.
 *
 * @builtin
 */
class BuiltinPreset extends Preset {
  constructor() {
    super(...arguments);

    _defineProperty(this, "onAddCustomHandler", handlers => {
      var suggester = handlers.suggester,
          keymap = handlers.keymap;

      if (suggester) {
        return this.getExtension(SuggestExtension).addCustomHandler('suggester', suggester);
      }

      if (keymap) {
        return this.getExtension(KeymapExtension).addCustomHandler('keymap', keymap);
      }

      return noop;
    });
  }

  get name() {
    return 'builtin';
  }

  onSetOptions(parameter) {
    var pickChanged = parameter.pickChanged;
    var changedKeymapOptions = pickChanged(['selectParentNodeOnEscape', 'excludeBaseKeymap', 'undoInputRuleOnBackspace']);

    if (!isEmptyObject(changedKeymapOptions)) {
      this.getExtension(KeymapExtension).setOptions(changedKeymapOptions);
    }
  }

  createExtensions() {
    var keymapOptions = pick(this.options, ['excludeBaseKeymap', 'selectParentNodeOnEscape', 'undoInputRuleOnBackspace']);
    return [new SchemaExtension(), new TagsExtension(), new AttributesExtension(), new PluginsExtension(), new InputRulesExtension(), new PasteRulesExtension(), new NodeViewsExtension(), new SuggestExtension(), new CommandsExtension(), new HelpersExtension(), new KeymapExtension(keymapOptions)];
  }

}

function ownKeys$5(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$5(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$5(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$5(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createForOfIteratorHelper$f(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray$f(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray$f(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$f(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$f(o, minLen); }

function _arrayLikeToArray$f(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/**
 * Check if the active selection has a cursor available.
 */
function selectionHasCursor(selection) {
  return isTextSelection(selection) ? bool(selection.$cursor) : false;
}

/**
 * Verifies that the mark can be applied
 */
function markApplies(parameter) {
  var doc = parameter.doc,
      ranges = parameter.ranges,
      type = parameter.type;

  var _iterator = _createForOfIteratorHelper$f(ranges),
      _step;

  try {
    var _loop = function _loop() {
      var _step$value = _step.value,
          $from = _step$value.$from,
          $to = _step$value.$to;
      var can = $from.depth === 0 ? doc.type.allowsMarkType(type) : false;
      doc.nodesBetween($from.pos, $to.pos, node => {
        if (can) {
          return false;
        }

        can = node.inlineContent && node.type.allowsMarkType(type);
        return;
      });

      if (can) {
        return {
          v: true
        };
      }
    };

    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _ret = _loop();

      if (typeof _ret === "object") return _ret.v;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return false;
}

function toggleActiveMarkSelection(parameter) {
  var tr = parameter.tr,
      type = parameter.type,
      attrs = parameter.attrs;
  var ranges = tr.selection.ranges;
  var selectionHasActiveMark = false;

  for (var rangesIndex = 0; !selectionHasActiveMark && rangesIndex < ranges.length; rangesIndex++) {
    var _ranges$rangesIndex = ranges[rangesIndex],
        $from = _ranges$rangesIndex.$from,
        $to = _ranges$rangesIndex.$to;
    selectionHasActiveMark = tr.doc.rangeHasMark($from.pos, $to.pos, type);
  }

  var _iterator2 = _createForOfIteratorHelper$f(ranges),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var _step2$value = _step2.value,
          _$from = _step2$value.$from,
          _$to = _step2$value.$to;

      if (selectionHasActiveMark) {
        tr.removeMark(_$from.pos, _$to.pos, type);
        continue;
      }

      tr.addMark(_$from.pos, _$to.pos, type.create(attrs));
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
}

/**
 * A command function that works for the remirror codebase.
 *
 * Create a command function that toggles the given mark with the given
 * attributes. Will return `false` when the current selection doesn't support
 * that mark. This will remove the mark if any marks of that type exist in the
 * selection, or add it otherwise. If the selection is empty, this applies to
 * the [stored marks](#state.EditorState.storedMarks) instead of a range of the
 * document.
 *
 * The differences from the `prosemirror-commands` version.
 * - Acts on the transaction rather than the state to allow for commands to be
 *   chained together.
 * - Uses the ONE parameter function signature for compatibility with remirror.
 * - Supports passing a custom range.
 */
function toggleMark(parameter) {
  var type = parameter.type,
      attrs = parameter.attrs,
      range = parameter.range;
  return (_ref) => {
    var dispatch = _ref.dispatch,
        tr = _ref.tr;
    var selection = tr.selection; // Selection picked from transaction to allow for chaining.

    var empty = selection.empty,
        ranges = selection.ranges;
    var useCurrentSelection = !range;

    if ( // When using the current selection
    useCurrentSelection && ( // Check that this is a valid and usable selection
    empty && !selectionHasCursor(selection) || // If not make sure that the mark can be applied.
    !markApplies({
      doc: tr.doc,
      ranges,
      type
    }))) {
      // Otherwise return false
      return false;
    } // This keeps the method idempotent. The transaction should not be mutated
    // if no dispatch is available.


    if (!dispatch) {
      return true;
    } // Wrap dispatch with an automatic true return. This removes the need for
    // even more `return true` statements.


    var done = () => {
      dispatch(tr);
      return true;
    };

    if (range) {
      isMarkActive(_objectSpread$5({
        stateOrTransaction: tr,
        type
      }, range)) ? tr.removeMark(range.from, range.to, type) : tr.addMark(range.from, range.to, type.create(attrs));
      return done();
    }

    if (selectionHasCursor(selection)) {
      if (type.isInSet(tr.storedMarks || selection.$cursor.marks())) {
        tr.removeStoredMark(type);
        return done();
      }

      tr.addStoredMark(type.create(attrs));
      return done();
    }

    toggleActiveMarkSelection({
      tr,
      type,
      attrs
    }); // Scroll into view is needed for very long selections.

    tr.scrollIntoView();
    return done();
  };
}

function ownKeys$6(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$6(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$6(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$6(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createForOfIteratorHelper$g(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray$g(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray$g(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$g(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$g(o, minLen); }

function _arrayLikeToArray$g(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var _uid = /*#__PURE__*/new WeakMap();

var _getProps = /*#__PURE__*/new WeakMap();

var _previousState = /*#__PURE__*/new WeakMap();

var _firstRender = /*#__PURE__*/new WeakMap();

var _events = /*#__PURE__*/new WeakMap();

var _disposers = /*#__PURE__*/new WeakMap();

var _getExtension = /*#__PURE__*/new WeakMap();

var _getPreset = /*#__PURE__*/new WeakMap();

class EditorWrapper {
  /**
   * A unique ID for the editor which is also used as a key to pass into
   * `getRootProps`.
   */

  /**
   * A method which enables retrieving the props from the editor.
   */

  /**
   * The private reference to the previous state.
   */

  /**
   * True when this is the first render.
   */

  /**
   * The event listener which allows consumers to subscribe to the different
   * events without using props.
   */

  /**
   * Array of disposal methods.
   */

  /**
   * The updatable view props.
   */
  get updatableViewProps() {
    return {
      attributes: () => this.getAttributes(),
      editable: () => {
        var _this$props$editable;

        return (_this$props$editable = this.props.editable) !== null && _this$props$editable !== void 0 ? _this$props$editable : true;
      },
      nodeViews: this.manager.store.nodeViews
    };
  }
  /**
   * The props passed in when creating or updating the `EditorWrapper` instance.
   */


  get props() {
    return _classPrivateFieldGet(this, _getProps).call(this);
  }
  /**
   * Returns the previous editor state. On the first render it defaults to
   * returning the current state. For the first render the previous state and
   * current state will always be equal.
   */


  get previousState() {
    var _ref, _this$previousStateOv;

    return (_ref = (_this$previousStateOv = this.previousStateOverride) !== null && _this$previousStateOv !== void 0 ? _this$previousStateOv : _classPrivateFieldGet(this, _previousState)) !== null && _ref !== void 0 ? _ref : this.view.state;
  }
  /**
   * Create the editor state from a remirror content type. This should be passed
   * in during initialization.
   */


  /**
   * A utility for quickly retrieving the extension manager.
   */
  get manager() {
    return this.props.manager;
  }
  /**
   * The prosemirror EditorView.
   */


  get view() {
    return this.manager.view;
  }
  /**
   * The document to use when rendering.
   */


  get doc() {
    return getDocument(this.props.forceEnvironment);
  }

  get uid() {
    return _classPrivateFieldGet(this, _uid);
  }

  constructor(_parameter) {
    var _this = this;

    _uid.set(this, {
      writable: true,
      value: uniqueId()
    });

    _getProps.set(this, {
      writable: true,
      value: void 0
    });

    _previousState.set(this, {
      writable: true,
      value: void 0
    });

    _firstRender.set(this, {
      writable: true,
      value: true
    });

    _events.set(this, {
      writable: true,
      value: createNanoEvents()
    });

    _disposers.set(this, {
      writable: true,
      value: []
    });

    _getExtension.set(this, {
      writable: true,
      value: void 0
    });

    _getPreset.set(this, {
      writable: true,
      value: void 0
    });

    _defineProperty(this, "getState", () => this.view.state);

    _defineProperty(this, "getPreviousState", () => this.previousState);

    _defineProperty(this, "dispatchTransaction", tr => {
      var _this$props$onDispatc, _this$props$onDispatc2, _this$props;

      if (this.manager.destroyed) {
        // TODO: this should be made to never happen.
        return;
      }

      tr = (_this$props$onDispatc = (_this$props$onDispatc2 = (_this$props = this.props).onDispatchTransaction) === null || _this$props$onDispatc2 === void 0 ? void 0 : _this$props$onDispatc2.call(_this$props, tr, this.getState())) !== null && _this$props$onDispatc !== void 0 ? _this$props$onDispatc : tr;
      var previousState = this.getState();

      var _previousState$applyT = previousState.applyTransaction(tr),
          state = _previousState$applyT.state,
          transactions = _previousState$applyT.transactions;

      _classPrivateFieldSet(this, _previousState, previousState); // Use the abstract method to update the state.


      this.updateState({
        state,
        tr,
        transactions
      }); // Update the view props when an update is requested

      var forcedUpdates = this.manager.store.getForcedUpdates(tr);

      if (!isEmptyArray(forcedUpdates)) {
        this.updateViewProps(...this.manager.store.getForcedUpdates(tr));
      }
    });

    _defineProperty(this, "onChange", function () {
      var _this$props$onChange, _this$props2;

      var parameter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : object();
      (_this$props$onChange = (_this$props2 = _this.props).onChange) === null || _this$props$onChange === void 0 ? void 0 : _this$props$onChange.call(_this$props2, _this.eventListenerParameter(parameter));

      if (_classPrivateFieldGet(_this, _firstRender)) {
        _classPrivateFieldSet(_this, _firstRender, false);
      }
    });

    _defineProperty(this, "onBlur", event => {
      var _this$props$onBlur, _this$props3;

      var parameter = this.eventListenerParameter();
      (_this$props$onBlur = (_this$props3 = this.props).onBlur) === null || _this$props$onBlur === void 0 ? void 0 : _this$props$onBlur.call(_this$props3, parameter, event);

      _classPrivateFieldGet(this, _events).emit('blur', parameter, event);
    });

    _defineProperty(this, "onFocus", event => {
      var _this$props$onFocus, _this$props4;

      var parameter = this.eventListenerParameter();
      (_this$props$onFocus = (_this$props4 = this.props).onFocus) === null || _this$props$onFocus === void 0 ? void 0 : _this$props$onFocus.call(_this$props4, parameter, event);

      _classPrivateFieldGet(this, _events).emit('focus', parameter, event);
    });

    _defineProperty(this, "setContent", function (content) {
      var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref2$triggerChange = _ref2.triggerChange,
          triggerChange = _ref2$triggerChange === void 0 ? false : _ref2$triggerChange;

      var state = _this.createStateFromContent(content);

      _this.updateState({
        state,
        triggerChange
      });
    });

    _defineProperty(this, "clearContent", function () {
      var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref3$triggerChange = _ref3.triggerChange,
          triggerChange = _ref3$triggerChange === void 0 ? false : _ref3$triggerChange;

      var onError = _this.props.onError;
      var content = isFunction(onError) ? onError() : onError !== null && onError !== void 0 ? onError : EMPTY_PARAGRAPH_NODE;

      _this.setContent(content, {
        triggerChange
      });
    });

    _defineProperty(this, "focus", position => {
      if (position === false) {
        return;
      }

      if (this.view.hasFocus() && (position === undefined || position === true)) {
        return;
      }

      var _this$getState = this.getState(),
          selection = _this$getState.selection,
          doc = _this$getState.doc,
          tr = _this$getState.tr;

      var _selection$from = selection.from,
          from = _selection$from === void 0 ? 0 : _selection$from,
          _selection$to = selection.to,
          to = _selection$to === void 0 ? from : _selection$to;

      if (position === undefined || position === true) {
        position = {
          from,
          to
        };
      }

      this.dispatchSelection(tr, getTextSelection(position, doc));
    });

    _defineProperty(this, "blur", () => {
      var dom = this.view.dom;

      if (!this.view.hasFocus()) {
        return;
      }

      if (!isElementDomNode(dom)) {
        return;
      }

      dom.blur();
    });

    _defineProperty(this, "getText", state => function () {
      var lineBreakDivider = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '\n\n';

      var _ref4 = state !== null && state !== void 0 ? state : _this.getState(),
          doc = _ref4.doc;

      return doc.textBetween(0, doc.content.size, lineBreakDivider);
    });

    _defineProperty(this, "getHTML", state => () => {
      return toHtml({
        node: (state !== null && state !== void 0 ? state : this.getState()).doc,
        schema: this.manager.store.schema,
        doc: this.doc
      });
    });

    _defineProperty(this, "getJSON", state => () => {
      return (state !== null && state !== void 0 ? state : this.getState()).toJSON();
    });

    _defineProperty(this, "getRemirrorJSON", state => () => {
      return (state !== null && state !== void 0 ? state : this.getState()).doc.toJSON();
    });

    var getProps = _parameter.getProps,
        createStateFromContent = _parameter.createStateFromContent,
        initialEditorState = _parameter.initialEditorState,
        element = _parameter.element;

    _classPrivateFieldSet(this, _getProps, getProps);

    this.createStateFromContent = createStateFromContent; // Add the getters

    _classPrivateFieldSet(this, _getExtension, this.manager.getExtension.bind(this.manager));

    _classPrivateFieldSet(this, _getPreset, this.manager.getPreset.bind(this.manager));

    if (this.manager.view) {
      return;
    } // Create the ProsemirrorView and initialize our editor manager with it.


    var view = this.createView(initialEditorState, element);
    this.manager.addView(view);
    this.setupEvents();
  }
  /**
   * Setup the manager event listeners which are disposed of when the manager is
   * destroyed.
   */


  setupEvents() {
    var disposeStateUpdate = this.manager.addHandler('stateUpdate', (_ref5) => {
      var state = _ref5.state,
          tr = _ref5.tr;
      return _classPrivateFieldGet(this, _events).emit('updated', this.eventListenerParameter({
        state,
        tr
      }));
    });
    var disposeDestroy = this.manager.addHandler('destroy', () => {
      _classPrivateFieldGet(this, _events).emit('destroy');

      var _iterator = _createForOfIteratorHelper$g(_classPrivateFieldGet(this, _disposers)),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var dispose = _step.value;
          dispose();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      _classPrivateFieldSet(this, _disposers, []);
    });

    _classPrivateFieldGet(this, _disposers).push(disposeStateUpdate, disposeDestroy);
  }
  /**
   * Update the constructor props passed in. Useful for frameworks like react
   * where props are constantly changing.
   */


  update(parameter) {
    var getProps = parameter.getProps,
        createStateFromContent = parameter.createStateFromContent;

    _classPrivateFieldSet(this, _getProps, getProps);

    this.createStateFromContent = createStateFromContent;
    return this;
  }
  /**
   * Retrieve the editor state.
   */


  /**
   * Update the view props.
   */
  updateViewProps() {
    for (var _len = arguments.length, keys = new Array(_len), _key = 0; _key < _len; _key++) {
      keys[_key] = arguments[_key];
    }

    var props = pick(this.updatableViewProps, keys);
    this.view.setProps(_objectSpread$6(_objectSpread$6({}, this.view.props), props));
  }
  /**
   * This sets the attributes for the prosemirror dom node..
   */


  getAttributes(ssr) {
    var _this$manager$store, _this$props$editable2, _this$props$label;

    var _this$props5 = this.props,
        attributes = _this$props5.attributes,
        autoFocus = _this$props5.autoFocus;
    var propertyAttributes = isFunction(attributes) ? attributes(this.eventListenerParameter()) : attributes;
    var managerAttributes = (_this$manager$store = this.manager.store) === null || _this$manager$store === void 0 ? void 0 : _this$manager$store.attributes;
    var focus = ssr ? {
      autoFocus: bool(autoFocus)
    } : {
      autofocus: autoFocus ? 'true' : 'false'
    };

    var defaultAttributes = _objectSpread$6(_objectSpread$6(_objectSpread$6(_objectSpread$6({
      role: 'textbox'
    }, focus), {}, {
      'aria-multiline': 'true'
    }, !((_this$props$editable2 = this.props.editable) !== null && _this$props$editable2 !== void 0 ? _this$props$editable2 : true) ? {
      'aria-readonly': 'true'
    } : {}), {}, {
      'aria-label': (_this$props$label = this.props.label) !== null && _this$props$label !== void 0 ? _this$props$label : ''
    }, managerAttributes), {}, {
      class: cx(ssr && 'Prosemirror', EDITOR_CLASS_NAME, managerAttributes === null || managerAttributes === void 0 ? void 0 : managerAttributes.class)
    });

    return _objectSpread$6(_objectSpread$6({}, defaultAttributes), propertyAttributes);
  }
  /**
   * Part of the Prosemirror API and is called whenever there is state change in
   * the editor.
   *
   * @internalremarks
   * How does it work when transactions are dispatched one after the other.
   */


  /**
   * Add `onBlur` and `onFocus` listeners.
   */
  addFocusListeners() {
    this.view.dom.addEventListener('blur', this.onBlur);
    this.view.dom.addEventListener('focus', this.onFocus);
  }
  /**
   * Remove `onBlur` and `onFocus` listeners.
   */


  removeFocusListeners() {
    this.view.dom.removeEventListener('blur', this.onBlur);
    this.view.dom.removeEventListener('focus', this.onFocus);
  }
  /**
   * Called when the component unmounts and is responsible for cleanup.
   *
   * @remarks
   *
   * - Removes listeners for the editor `blur` and `focus` events
   * - Destroys the state for each plugin
   * - Destroys the manager which destroys the editor view.
   */


  onDestroy() {
    this.removeFocusListeners();
  }
  /**
   * Use this method in the `onUpdate` event to run all change handlers.
   */


  /**
   * The params used in the event listeners and the state listener
   */
  baseListenerParameter(parameter) {
    var state = parameter.state,
        tr = parameter.tr;
    return {
      tr,
      internalUpdate: !tr,
      view: this.view,
      getHTML: this.getHTML(state),
      getJSON: this.getJSON(state),
      getRemirrorJSON: this.getRemirrorJSON(state),
      getText: this.getText(state)
    };
  }
  /**
   * Creates the parameters passed into all event listener handlers. e.g.
   * `onChange`
   */


  eventListenerParameter() {
    var parameter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : object();
    var state = parameter.state,
        tr = parameter.tr;
    return _objectSpread$6(_objectSpread$6({
      firstRender: _classPrivateFieldGet(this, _firstRender)
    }, this.baseListenerParameter({
      tr,
      state
    })), {}, {
      state: state !== null && state !== void 0 ? state : this.getState(),
      createStateFromContent: this.createStateFromContent,
      previousState: this.previousState
    });
  }
  /**
   * Set the focus for the editor.
   */


  /**
   * Dispatch the text selection
   */
  dispatchSelection(tr, selection) {
    // Set the selection to the requested value
    var transaction = tr.setSelection(selection);
    this.view.dispatch(transaction); // Wait for the next event loop to set the focus.

    requestAnimationFrame(() => this.view.focus());
  }

  get editorWrapperOutput() {
    return _objectSpread$6(_objectSpread$6({}, this.manager.store), {}, {
      addHandler: _classPrivateFieldGet(this, _events).on.bind(_classPrivateFieldGet(this, _events)),

      /* Properties */
      uid: _classPrivateFieldGet(this, _uid),
      manager: this.manager,
      view: this.view,

      /* Getter Methods */
      getState: this.getState,
      getPreviousState: this.getPreviousState,
      getExtension: _classPrivateFieldGet(this, _getExtension),
      getPreset: _classPrivateFieldGet(this, _getPreset),

      /* Setter Methods */
      clearContent: this.clearContent,
      setContent: this.setContent,

      /* Helper Methods */
      focus: this.focus,
      blur: this.blur
    });
  }

}

/**
 * A value that can be used in this package to prevent a method being called by
 * external users. If not present it can throw a runtime error.
 *
 * @remarks
 *
 * For example, this is the internal value which is used to check that the
 * editor manager was not created using the `new RemirrorManager` operator. It
 * must be provided to the constructor and if it isn't there it will cause the
 * manager to throw an error.
 */
var privacySymbol = /*#__PURE__*/Symbol('privacy');

function _createForOfIteratorHelper$h(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray$h(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray$h(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$h(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$h(o, minLen); }

function _arrayLikeToArray$h(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/**
 * Transforms the unsorted array of presets and extension into presets and
 * sorted extensions. Handles uniqueness of extensions and automatically pulling
 * throwing an error when required extensions are missing.
 *
 * TODO Add a check for requiredExtensions and inject them automatically TODO
 * Currently matching by constructor - what if different versions exist in the
 * same app...
 *
 * @param unionValues - the extensions to transform as well as their priorities
 *
 * @returns the list of extension instances sorted by priority
 */
function transformCombinedUnion(unionValues, settings) {
  // The items to return.
  var presets = [];
  var presetMap = new WeakMap();
  var extensions = [];
  var extensionMap = new WeakMap(); // Used to track duplicates and the presets they've been added by.

  var duplicateMap = new WeakMap(); // The unsorted, de-duped, unrefined extensions.

  var rawExtensions = [];
  /**
   * Adds the values to the duplicate map for checking duplicates.
   */

  var updateExtensionDuplicates = (extension, preset) => {
    var key = extension.constructor;
    var duplicate = duplicateMap.get(key);
    duplicateMap.set(key, duplicate ? [...duplicate, preset] : [preset]);
  };

  var _iterator = _createForOfIteratorHelper$h(unionValues),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var presetOrExtension = _step.value;

      // Update the extension list in this block
      if (isExtension(presetOrExtension)) {
        var _settings$priority;

        presetOrExtension.setPriority((_settings$priority = settings.priority) === null || _settings$priority === void 0 ? void 0 : _settings$priority[presetOrExtension.name]);
        rawExtensions.push(presetOrExtension);
        updateExtensionDuplicates(presetOrExtension);
        continue;
      } // Update the presets list in this block


      if (isPreset(presetOrExtension)) {
        presets.push(presetOrExtension);
        presetMap.set(presetOrExtension.constructor, presetOrExtension);

        var _iterator4 = _createForOfIteratorHelper$h(presetOrExtension.extensions),
            _step4;

        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var _settings$priority2;

            var _extension = _step4.value;

            _extension.setPriority((_settings$priority2 = settings.priority) === null || _settings$priority2 === void 0 ? void 0 : _settings$priority2[_extension.name]);

            updateExtensionDuplicates(_extension, presetOrExtension);
            rawExtensions.push(_extension);
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }

        continue;
      } // TODO: Allow constructors to be auto instantiated.
      // This is only reached if the passed value is invalid.


      !false ? process.env.NODE_ENV !== "production" ? invariant(false, {
        code: ErrorConstant.INVALID_MANAGER_ARGUMENTS
      }) : invariant(false) : void 0;
    } // Sort the extensions.

  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  rawExtensions = sort(rawExtensions, (a, b) => b.priority - a.priority); // Keep track of added constructors for uniqueness.

  var found = new WeakSet();
  var names = new Set(); // Remove extension duplicates and update the preset with the non duplicated
  // value.

  var _iterator2 = _createForOfIteratorHelper$h(rawExtensions),
      _step2;

  try {
    var _loop = function _loop() {
      var extension = _step2.value;
      var key = extension.constructor;
      var name = extension.name;
      var duplicates = duplicateMap.get(key);
      !duplicates ? process.env.NODE_ENV !== "production" ? invariant(false, {
        message: "No entries where found for the ExtensionConstructor ".concat(extension.name),
        code: ErrorConstant.INTERNAL
      }) : invariant(false) : void 0;

      if (found.has(key) || names.has(name)) {
        return "continue";
      }

      found.add(key);
      names.add(name);
      extensions.push(extension);
      extensionMap.set(key, extension); // Replace the extensions for all presets that referenced this constructor.

      duplicates.forEach(preset => preset === null || preset === void 0 ? void 0 : preset.replaceExtension(key, extension));
    };

    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var _ret = _loop();

      if (_ret === "continue") continue;
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  var missing = [];
  /**
   * Populate the missing Constructors.
   */

  var findMissingExtensions = extension => {
    var _extension$requiredEx;

    if (!extension.requiredExtensions) {
      return;
    }

    var _iterator3 = _createForOfIteratorHelper$h((_extension$requiredEx = extension.requiredExtensions) !== null && _extension$requiredEx !== void 0 ? _extension$requiredEx : []),
        _step3;

    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var Constructor = _step3.value;

        if (found.has(Constructor)) {
          continue;
        }

        missing.push({
          Constructor: Constructor,
          extension
        });
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
  }; // Throw if any required extension missing.


  for (var _i = 0, _extensions = extensions; _i < _extensions.length; _i++) {
    var extension = _extensions[_i];
    findMissingExtensions(extension);
  }

  !isEmptyArray(missing) ? process.env.NODE_ENV !== "production" ? invariant(false, {
    code: ErrorConstant.MISSING_REQUIRED_EXTENSION,
    message: missing.map((_ref) => {
      var Constructor = _ref.Constructor,
          extension = _ref.extension;
      return "The extension '".concat(extension.name, "' requires '").concat(Constructor.name, " in order to run correctly.");
    }).join('\n')
  }) : invariant(false) : void 0;
  return {
    extensions,
    extensionMap,
    presets,
    presetMap
  };
}

function _createForOfIteratorHelper$i(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray$i(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray$i(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$i(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$i(o, minLen); }

function _arrayLikeToArray$i(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys$7(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$7(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$7(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$7(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
/**
 * The `Manager` has multiple hook phases which are able to hook into the
 * extension manager flow and add new functionality to the editor.
 *
 * The `ExtensionEventMethod`s
 *
 * - onCreate - when the extension manager is created and after the schema is
 *   made available.
 * - onView - when the view has been received from the dom ref.
 */

/**
 * A class to manage the extensions and prosemirror interactions of our editor.
 *
 * @remarks
 *
 * The extension manager has three phases of Initialization:
 *
 * - Construction - This takes in all the extensions and creates the schema.
 *
 * ```ts
 * const manager = Manager.create([ new DocExtension(), new TextExtension(), new ParagraphExtension()])
 * ```
 *
 * - Initialize Getters - This connects the extension manager to the lazily
 *   evaluated `getState` method and the `portalContainer`. Once these are
 *   created and allows access to its data.
 *
 * ```ts
 * manager.init({ getState: () => state, portalContainer: new PortalContainer })
 *
 * manager.data.
 * ```
 *
 * - Initialize View - This connects the extension manager to the EditorView and
 *   creates the actions (which need access to the view).
 *
 * ```ts
 * manager.initView(new EditorView(...))
 * manager.data.actions
 * ```
 */

var _extensionStore$1 = /*#__PURE__*/new WeakMap();

var _extensions$1 = /*#__PURE__*/new WeakMap();

var _extensionMap$1 = /*#__PURE__*/new WeakMap();

var _presets = /*#__PURE__*/new WeakMap();

var _presetMap = /*#__PURE__*/new WeakMap();

var _store$1 = /*#__PURE__*/new WeakMap();

var _phase = /*#__PURE__*/new WeakMap();

var _settings = /*#__PURE__*/new WeakMap();

var _combined = /*#__PURE__*/new WeakMap();

var _firstStateUpdate = /*#__PURE__*/new WeakMap();

var _handlers = /*#__PURE__*/new WeakMap();

var _events$1 = /*#__PURE__*/new WeakMap();

class RemirrorManager {
  /**
   * The main static method for creating a manager.
   */
  static create(combined) {
    var settings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return new RemirrorManager([...getLazyArray(combined), new BuiltinPreset(settings.builtin)], _objectSpread$7(_objectSpread$7({}, settings), {}, {
      privacy: privacySymbol
    }));
  }
  /**
   * A static method to create the editor manager from an object.
   */


  static fromObject(_ref) {
    var extensions = _ref.extensions,
        presets = _ref.presets,
        _ref$settings = _ref.settings,
        settings = _ref$settings === void 0 ? {} : _ref$settings;
    return RemirrorManager.create([...extensions, ...presets], settings);
  }
  /**
   * Utility getter for storing the base method parameter which is available to
   * all extensions.
   */


  /**
   * Returns true if the manager has been destroyed.
   */
  get destroyed() {
    return _classPrivateFieldGet(this, _phase) === ManagerPhase.Destroy;
  }
  /**
   * True when the view has been added to the UI layer and the editor is running.
   */


  get mounted() {
    return _classPrivateFieldGet(this, _phase) >= ManagerPhase.EditorView && _classPrivateFieldGet(this, _phase) < ManagerPhase.Destroy;
  }
  /**
   * Identifies this as a `Manager`.
   *
   * @internal
   */


  get [__INTERNAL_REMIRROR_IDENTIFIER_KEY__]() {
    return RemirrorIdentifier.Manager;
  }
  /**
   * The extensions stored by this manager
   */


  get extensions() {
    return _classPrivateFieldGet(this, _extensions$1);
  }
  /**
   * The preset stored by this manager
   */


  get presets() {
    return _classPrivateFieldGet(this, _presets);
  }
  /**
   * Get the original combined presets used to create this manager.
   */


  get combined() {
    return freeze(_classPrivateFieldGet(this, _combined));
  }
  /**
   * Get the extension manager store which is accessible at initialization.
   */


  get store() {
    return freeze(_classPrivateFieldGet(this, _store$1));
  }
  /**
   * Returns the stored nodes
   */


  get nodes() {
    return _classPrivateFieldGet(this, _store$1).nodes;
  }
  /**
   * Returns the store marks.
   */


  get marks() {
    return _classPrivateFieldGet(this, _store$1).marks;
  }
  /**
   * A shorthand method for retrieving the schema for this extension manager
   * from the data.
   */


  get schema() {
    return _classPrivateFieldGet(this, _store$1).schema;
  }
  /**
   * A shorthand getter for retrieving the tags from the extension manager.
   */


  get extensionTags() {
    return _classPrivateFieldGet(this, _store$1).tags;
  }
  /**
   * A shorthand way of retrieving the editor view.
   */


  get view() {
    return _classPrivateFieldGet(this, _store$1).view;
  }
  /**
   * Retrieve the settings used when creating the manager.
   */


  get settings() {
    return _classPrivateFieldGet(this, _settings);
  }
  /**
   * Creates the extension manager which is used to simplify the management of
   * the prosemirror editor.
   *
   * This should not be called directly if you want to use prioritized
   * extensions. Instead use `RemirrorManager.create([])`.
   */


  constructor(combined) {
    var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var privacy = _ref2.privacy,
        settings = _objectWithoutProperties(_ref2, ["privacy"]);

    _extensionStore$1.set(this, {
      writable: true,
      value: void 0
    });

    _extensions$1.set(this, {
      writable: true,
      value: void 0
    });

    _extensionMap$1.set(this, {
      writable: true,
      value: void 0
    });

    _presets.set(this, {
      writable: true,
      value: void 0
    });

    _presetMap.set(this, {
      writable: true,
      value: void 0
    });

    _store$1.set(this, {
      writable: true,
      value: this.createInitialStore()
    });

    _phase.set(this, {
      writable: true,
      value: ManagerPhase.None
    });

    _settings.set(this, {
      writable: true,
      value: void 0
    });

    _combined.set(this, {
      writable: true,
      value: void 0
    });

    _firstStateUpdate.set(this, {
      writable: true,
      value: true
    });

    _handlers.set(this, {
      writable: true,
      value: {
        create: [],
        view: [],
        update: [],
        destroy: []
      }
    });

    _events$1.set(this, {
      writable: true,
      value: createNanoEvents()
    });

    _defineProperty(this, "setStoreKey", (key, value) => {
      _classPrivateFieldGet(this, _store$1)[key] = value;
    });

    _defineProperty(this, "getStoreKey", key => {
      var value = _classPrivateFieldGet(this, _store$1)[key];

      !!isNullOrUndefined(value) ? process.env.NODE_ENV !== "production" ? invariant(false, {
        code: ErrorConstant.MANAGER_PHASE_ERROR,
        message: '`getStoreKey` should not be called before the values are available.'
      }) : invariant(false) : void 0;
      return value;
    });

    _defineProperty(this, "setExtensionStore", (key, value) => {
      !(_classPrivateFieldGet(this, _phase) <= ManagerPhase.Create) ? process.env.NODE_ENV !== "production" ? invariant(false, {
        code: ErrorConstant.MANAGER_PHASE_ERROR,
        message: '`setExtensionStore` should only be called during the `onCreate` lifecycle hook. Make sure to only call it within the returned methods.'
      }) : invariant(false) : void 0;
      _classPrivateFieldGet(this, _extensionStore$1)[key] = value;
    });

    _defineProperty(this, "getState", () => {
      !(_classPrivateFieldGet(this, _phase) >= ManagerPhase.EditorView) ? process.env.NODE_ENV !== "production" ? invariant(false, {
        code: ErrorConstant.MANAGER_PHASE_ERROR,
        message: '`getState` can only be called after the view has been added to the manager. Avoid using it in the outer scope of `creatorMethods`.'
      }) : invariant(false) : void 0;
      return this.view.state;
    });

    _defineProperty(this, "updateState", state => {
      var previousState = this.getState();
      this.view.updateState(state);
      this.onStateUpdate({
        previousState,
        state
      });
    });

    _classPrivateFieldSet(this, _settings, settings);

    _classPrivateFieldSet(this, _combined, combined);

    !(privacy === privacySymbol) ? process.env.NODE_ENV !== "production" ? invariant(false, {
      message: "The extension manager can only be invoked via one of it's static methods. e.g 'RemirrorManager.create([...extensions])'.",
      code: ErrorConstant.NEW_EDITOR_MANAGER
    }) : invariant(false) : void 0;

    var _transformCombinedUni = transformCombinedUnion(combined, settings),
        extensions = _transformCombinedUni.extensions,
        extensionMap = _transformCombinedUni.extensionMap,
        presets = _transformCombinedUni.presets,
        presetMap = _transformCombinedUni.presetMap;

    _classPrivateFieldSet(this, _extensions$1, freeze(extensions));

    _classPrivateFieldSet(this, _extensionMap$1, extensionMap);

    _classPrivateFieldSet(this, _presets, freeze(presets));

    _classPrivateFieldSet(this, _presetMap, presetMap);

    _classPrivateFieldSet(this, _extensionStore$1, this.createExtensionStore());

    this.setupLifecycleHandlers();

    _classPrivateFieldSet(this, _phase, ManagerPhase.Create);

    var _iterator = _createForOfIteratorHelper$i(_classPrivateFieldGet(this, _handlers).create),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var handler = _step.value;
        handler();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  /**
   * Loops through all extensions to set up the lifecycle handlers.
   */


  setupLifecycleHandlers() {
    var _iterator2 = _createForOfIteratorHelper$i(_classPrivateFieldGet(this, _presets)),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var preset = _step2.value;
        preset.setExtensionStore(_classPrivateFieldGet(this, _extensionStore$1));
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }

    var nodeNames = [];
    var markNames = [];
    var plainNames = [];
    _classPrivateFieldGet(this, _extensionStore$1).nodeNames = nodeNames;
    _classPrivateFieldGet(this, _extensionStore$1).markNames = markNames;
    _classPrivateFieldGet(this, _extensionStore$1).plainNames = plainNames;

    var _iterator3 = _createForOfIteratorHelper$i(_classPrivateFieldGet(this, _extensions$1)),
        _step3;

    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var extension = _step3.value;
        extension.setStore(_classPrivateFieldGet(this, _extensionStore$1));
        var createHandler = extension.onCreate;
        var viewHandler = extension.onView;
        var stateUpdateHandler = extension.onStateUpdate;
        var destroyHandler = extension.onDestroy;

        if (createHandler) {
          _classPrivateFieldGet(this, _handlers).create.push(createHandler.bind(extension));
        }

        if (viewHandler) {
          _classPrivateFieldGet(this, _handlers).view.push(viewHandler.bind(extension));
        }

        if (stateUpdateHandler) {
          _classPrivateFieldGet(this, _handlers).update.push(stateUpdateHandler.bind(extension));
        }

        if (destroyHandler) {
          _classPrivateFieldGet(this, _handlers).destroy.push(destroyHandler.bind(extension));
        }

        if (isNodeExtension(extension)) {
          nodeNames.push(extension.name);
        }

        if (isMarkExtension(extension)) {
          markNames.push(extension.name);
        }

        if (isPlainExtension(extension)) {
          plainNames.push(extension.name);
        }
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
  }
  /**
   * Set the store key.
   */


  /**
   * Create the initial store.
   */
  createInitialStore() {
    var store = object();
    return store;
  }
  /**
   * Create the initial store.
   */


  createExtensionStore() {
    var store = object();
    Object.defineProperties(store, {
      extensions: {
        get: () => _classPrivateFieldGet(this, _extensions$1),
        enumerable: true
      },
      phase: {
        get: () => _classPrivateFieldGet(this, _phase),
        enumerable: true
      },
      view: {
        get: () => this.view,
        enumerable: true
      },
      managerSettings: {
        get: () => freeze(_classPrivateFieldGet(this, _settings)),
        enumerable: true
      },
      getState: {
        value: this.getState,
        enumerable: true
      },
      updateState: {
        value: this.updateState,
        enumerable: true
      },
      isMounted: {
        value: () => this.mounted,
        enumerable: true
      }
    });
    store.getStoreKey = this.getStoreKey;
    store.setStoreKey = this.setStoreKey;
    store.setExtensionStore = this.setExtensionStore;
    return store;
  }
  /**
   * A state getter method which is passed into the params.
   */


  /**
   * Stores the editor view on the manager
   *
   * @param view - the editor view
   */
  addView(view) {
    if (_classPrivateFieldGet(this, _phase) >= ManagerPhase.EditorView) {
      // Do nothing since a view has already been added.
      return this;
    } // invariant(this.#phase < ManagerPhase.EditorView, {code:
    //   ErrorConstant.MANAGER_PHASE_ERROR, message: 'A view has already been
    //   added to this manager. A view should only be added once.',
    // });


    _classPrivateFieldSet(this, _firstStateUpdate, true); // Update the lifecycle phase.


    _classPrivateFieldSet(this, _phase, ManagerPhase.EditorView); // Store the view.


    _classPrivateFieldGet(this, _store$1).view = view;

    var _iterator4 = _createForOfIteratorHelper$i(_classPrivateFieldGet(this, _handlers).view),
        _step4;

    try {
      for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
        var handler = _step4.value;
        handler(view);
      }
    } catch (err) {
      _iterator4.e(err);
    } finally {
      _iterator4.f();
    }

    return this;
  }
  /* Public Methods */

  /**
   * Create the editor state from content passed to this extension manager.
   */


  createState(parameter) {
    var content = parameter.content,
        docParameter = parameter.doc,
        stringHandler = parameter.stringHandler,
        onError = parameter.onError,
        selection = parameter.selection;
    var _this$store = this.store,
        schema = _this$store.schema,
        plugins = _this$store.plugins;
    var doc = createDocumentNode({
      content,
      doc: docParameter,
      schema,
      stringHandler,
      onError,
      selection
    });
    var state = EditorState.create({
      schema,
      doc,
      plugins
    });

    if (!selection) {
      return state;
    }

    var tr = state.tr.setSelection(getTextSelection(selection, state.doc));
    return state.applyTransaction(tr).state;
  }
  /**
   * Add a handler to the manager.
   *
   * Currently the only event that can be listend to is the `destroy` event.
   */


  addHandler(event, cb) {
    return _classPrivateFieldGet(this, _events$1).on(event, cb);
  }
  /**
   * Update the state of the view and trigger the `onStateUpdate` lifecyle
   * method as well.
   */


  /**
   * This method should be called by the view layer every time the state is
   * updated.
   *
   * An example usage of this is within the collaboration extension.
   */
  onStateUpdate(parameter) {
    var firstUpdate = _classPrivateFieldGet(this, _firstStateUpdate);

    _classPrivateFieldGet(this, _extensionStore$1).currentState = parameter.state;
    _classPrivateFieldGet(this, _extensionStore$1).previousState = parameter.previousState;

    if (_classPrivateFieldGet(this, _firstStateUpdate)) {
      _classPrivateFieldSet(this, _phase, ManagerPhase.Runtime);

      _classPrivateFieldSet(this, _firstStateUpdate, false);
    }

    var parameterWithUpdate = _objectSpread$7(_objectSpread$7({}, parameter), {}, {
      firstUpdate
    });

    var _iterator5 = _createForOfIteratorHelper$i(_classPrivateFieldGet(this, _handlers).update),
        _step5;

    try {
      for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
        var handler = _step5.value;
        handler(parameterWithUpdate);
      }
    } catch (err) {
      _iterator5.e(err);
    } finally {
      _iterator5.f();
    }

    _classPrivateFieldGet(this, _events$1).emit('stateUpdate', parameterWithUpdate);
  }
  /**
   * Get the extension instance matching the provided constructor from the
   * manager.
   *
   * This will throw an error if non existent.
   */


  getExtension(Constructor) {
    var extension = _classPrivateFieldGet(this, _extensionMap$1).get(Constructor); // Throws an error if attempting to get an extension which is not present in
    // the manager.


    !extension ? process.env.NODE_ENV !== "production" ? invariant(false, {
      code: ErrorConstant.INVALID_MANAGER_EXTENSION,
      message: "'".concat(Constructor.name, "' doesn't exist within this manager. Make sure it is properly added before attempting to use it.")
    }) : invariant(false) : void 0;
    return extension;
  }
  /**
   * Get the requested preset from the manager. This will throw if the preset doesn't
   * exist within this manager.
   */


  getPreset(Constructor) {
    var preset = _classPrivateFieldGet(this, _presetMap).get(Constructor); // Throws an error if attempting to retrieve a preset which is not present
    // in the manager.


    !preset ? process.env.NODE_ENV !== "production" ? invariant(false, {
      code: ErrorConstant.INVALID_MANAGER_PRESET,
      message: "'".concat(Constructor.name, "' doesn't exist within this manager. Make sure it is properly added before attempting to use it.")
    }) : invariant(false) : void 0;
    return preset;
  }
  /**
   * Make a clone .
   *
   * TODO: Think about the following.
   * - What about the state stored in the extensions and presets, does this need to be
   * recreated as well?
   */


  clone() {
    var currentCombined = _classPrivateFieldGet(this, _combined).map(e => e.clone(e.options));

    return RemirrorManager.create(currentCombined, _classPrivateFieldGet(this, _settings));
  }
  /**
   * Recreate the manager.
   *
   * TODO: Think about the following.
   * - What about the state stored in the extensions and presets, does this need to be
   * recreated as well?
   */


  recreate() {
    var combined = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var settings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var currentCombined = _classPrivateFieldGet(this, _combined).map(e => e.clone(e.initialOptions));

    return RemirrorManager.create([...currentCombined, ...combined], settings);
  }
  /**
   * This method should be called to destroy the manager and remove the view. You have full control over this.
   */


  destroy() {
    var _this$view, _this$view$state$plug, _this$view2;

    _classPrivateFieldSet(this, _phase, ManagerPhase.Destroy);

    var _iterator6 = _createForOfIteratorHelper$i((_this$view$state$plug = (_this$view2 = this.view) === null || _this$view2 === void 0 ? void 0 : _this$view2.state.plugins) !== null && _this$view$state$plug !== void 0 ? _this$view$state$plug : []),
        _step6;

    try {
      for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
        var _plugin$getState, _plugin$getState$dest;

        var plugin = _step6.value;
        (_plugin$getState = plugin.getState(this.view.state)) === null || _plugin$getState === void 0 ? void 0 : (_plugin$getState$dest = _plugin$getState.destroy) === null || _plugin$getState$dest === void 0 ? void 0 : _plugin$getState$dest.call(_plugin$getState);
      } // TODO: prevent `dispatchTransaction` from being called again

    } catch (err) {
      _iterator6.e(err);
    } finally {
      _iterator6.f();
    }

    var _iterator7 = _createForOfIteratorHelper$i(_classPrivateFieldGet(this, _handlers).destroy),
        _step7;

    try {
      for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
        var onDestroy = _step7.value;
        onDestroy();
      }
    } catch (err) {
      _iterator7.e(err);
    } finally {
      _iterator7.f();
    }

    (_this$view = this.view) === null || _this$view === void 0 ? void 0 : _this$view.destroy();

    _classPrivateFieldGet(this, _events$1).emit('destroy');
  }

}

/**
 * Checks to see whether the provided value is an `Manager`.
 *
 * @param value - the value to check
 */
function isRemirrorManager(value) {
  return isRemirrorType(value) && isIdentifierOfType(value, RemirrorIdentifier.Manager);
}

var editorStyles = "remirror-editor";

export { AttributesExtension, BuiltinPreset, CommandsExtension, EditorWrapper, HelpersExtension, InputRulesExtension, KeymapExtension, MarkExtension, NodeExtension, NodeViewsExtension, PasteRulesExtension, PlainExtension, PluginsExtension, Preset, RemirrorManager, SchemaExtension, SuggestExtension, TagsExtension, editorStyles, extensionDecorator, isExtension, isExtensionConstructor, isMarkExtension, isNodeExtension, isPlainExtension, isPreset, isPresetConstructor, isRemirrorManager, isValidExtensionConstructor, mutateDefaultExtensionOptions, presetDecorator, toggleMark };
